import { pathToRegexp } from 'path-to-regexp';

/**
 * 腾讯天御验证码APPID
 * appid: 190071233
 */
export const CAPTCHA_APPID = '190071233';

const path2regexp = (item: string) => pathToRegexp(item, undefined, { start: false });

/**
 * 投放落地页正则列表
 */
export const PromotionRegExpList = ['/lp/:serialNumber'].map(path2regexp);

/**
 * 落地页正则列表
 * 包含：异业渠道落地页、联合登录落地页、投放落地页、返利网落地页 '/channel/partner'
 */
export const LandingPageRegExpList = ['/channel/entrance', '/channel/federated', '/channel/partner']
  .map(path2regexp)
  .concat(PromotionRegExpList);

/**
 * 宜享花域名
 */
export const YXH_DOMAINS = [
  // 生产环境域名(海南小贷)
  'www.hainanwangdai.com',
  'm.hainanwangdai.com',
  'www.yxh1.cn',
  'www.yxh2.cn',
  'www.yxh3.cn',
  'www.yxh4.cn',

  // 生产环境域名(微佳)
  'm.vjia-tech.cn',
  'www.yxh5.cn',
  'www.yxh6.cn',

  // 预发环境域名
  'staging.hainanwangdai.com',

  // 测试环境域名
  'yrxd.test.creditease.cn',
  'yrxdtest.creditease.com',
];

/**
 * 业务状态码
 */
export const enum BizCode {
  /**
   * 成功
   * @type {String}
   */
  SUCCESS = '0000',
  /**
   * 未授权
   * @type {String}
   */
  UNAUTHORIZED = '0001',
  /**
   * 需要验证码
   */
  NEED_CAPTCHA = '0003',
  /**
   * 跳转下载APP
   */
  JUMP_TO_DOWNLOAD_APP = '0007',
  /**
   * 身份证示例浮层
   */
  ID_CARD_EXAMPLES = '5000',
  /**
   * OCR识别失败去下载APP
   */
  OCR_TO_DOWNLOAD_APP = '5001',
  /**
   * 资金源切换
   */
  FUND_PROVIDER_CHANGE = '0923',
  /**
   * 售罄
   */
  SELL_OUT = '9800',
  /**
   * 已绑定微信
   */
  ALREADY_BINDING_WECHAT = '97001',
}

/**
 * 资金路由状态
 */
export const enum FundRoutingStatus {
  /**
   * 需要银行卡
   */
  NEED_BANK_CARD = 0,
  /**
   * 路由中
   */
  ROUTING = 1,
  /**
   * 路由成功
   */
  SUCCESS = 2,
  /**
   * 二次风控拒贷
   */
  REJECTED = 3,
  /**
   * 签约失败
   */
  SIGN_FAILED = 4,
  /**
   * 资方签约协议
   */
  NEED_AGREEMENT_SIGN = 5,
  /**
   * 需要协议支付
   */
  NEED_AGREEMENT_PAY = 6,
  /**
   * 需要跳转到外部H5页面
   */
  OPEN_EXTERNAL_PAGE = 7,
  /**
   * 跳转放款结果页
   */
  LOAN_RESULT = 8,
  /**
   * 卡路由不跳转情况
   */
  LOAN_ERROR = 9,
  /*
   * 风控不降价强制取消合同
   */
  MANDATORY_REJECTED = 10,
  /**
   * 需要二次确认(36定价弹窗)
   */
  NEED_AGREEMENT_CONFIRM = 11,
  /**
   * 进入广告主
   */
  ENTER_PARTNER = 12,
  /**
   * 强制跳转进超时继续重新借款
   */
  TIMEOUT_CONTINUE_RE_BORROW = 13,
  /**
   * 预路由与正式路由返回结果不一致，前端跳转确认弹窗
   */
  LOAN_RESULT_PRE_PRICE = 14,

  /**
   * 首贷amc风险不降价 30分钟超时取消
   */
  LOAN_RESULT_PRE_PRICE_CANCEL = 15,
  /**
   * 路由成功后校验利率异常
   */
  LOAN_RESULT_PRE_PRICE_RATE_ERROR = 16,
  /**
   *  资金匹配需要展示跃升卡
   */
  NEED_SHOW_UPGRADE_CARD = 17,
  /**
   * 需要人脸校验
   */
  NEED_RISK_FACE = 18,
  /**
   * 需要人脸校验阻断
   */
  DYY_NEED_FACE_BLOCK = 19,
}

/**
 * 授信状态
 */
export const enum CreditStatus {
  /**
   * 未授信
   * @type {Number}
   */
  UNCREDITED = 1,
  /**
   * 弱拒贷
   * @type {Number}
   */
  WEAK_REJECTED = 2,
  /**
   * 强拒贷
   * @type {Number}
   */
  STRONG_REJECTED = 3,
  /**
   * 通过
   * @type {Number}
   */
  PASSED = 4,
  /**
   * 申请中
   * @type {Number}
   */
  PENDING = 5,
  /**
   * 人脸识别失败
   * @type {Number}
   */
  FACE_REJECTED = 6,
}

/**
 * 注销时的授信状态对应
 */
export const enum CloseAccountStatus {
  /**
   * 未授信
   * @type {Number}
   */
  UNCREDITED = 0,
  /**
   * 通过
   * @type {Number}
   */
  PASSED = 1,
  /**
   * 授信拒绝
   * @type {Number}
   */
  REJECTED = 2,
}

/**
 * 是否需要注销登记
 */
export const enum NeedCloseAccountRegister {
  /**
   * 需要
   * @type {Number}
   */
  NEED = 2,
  /**
   * 不需要
   * @type {Number}
   */
  NO_NEED = 1,
}

/**
 * 进件状态
 */
export const enum ApplyStatus {
  /**
   * 无正在进行中的借款
   */
  NOTHING = 0,
  /**
   * 申请中
   */
  APPLYING = 1,
  /**
   * 资金到账中
   */
  ARRIVING = 4,
  /**
   * 还款中
   */
  REPAYING = 5,
  /**
   * 资金到账异常
   */
  ARRIVE_FAILED = 6,
  /**
   * 签约成功
   */
  SIGNED = 7,
  /**
   * 放款中
   */
  LOANING = 8,
}

/**
 * API导流-进件状态
 */
export const enum PartnerApplyStatus {
  /**
   * 放款中
   */
  LOANING = 0,
  /**
   * 放款成功
   */
  SUCCESS = 1,
  /**
   * 失败
   */
  FAILED = -1,
}

/**
 * 授信类型
 */
export const enum CreditTypes {
  /**
   * 定额定期
   * @type {Number}
   */
  FIXED_CREDIT_LIMIT = 0,
  /**
   * 循环额度
   * @type {Number}
   */
  REVOLVING_CREDIT_LIMIT = 1,
}

/**
 * 额度状态
 */
export const enum CreditLimitStatus {
  /**
   * 正常
   * @type {Number}
   */
  LOANING = 0,
  /**
   * 冻结
   * @type {Number}
   */
  FROZEN = 1,
}

/**
 * 还款状态
 */
export const enum RepaymentStatus {
  /**
   * 出借中
   */
  LOANING = 0,
  /**
   * 已逾期
   * @type {Number}
   */
  OVERDUE = 1,
  /**
   * 已还款
   * @type {Number}
   */
  COMPLETED = 2,
}

/**
 * 还款结果状态
 */
export const enum RepaymentResultStatus {
  /**
   * 未知
   */
  UNKNOWN = 0,
  /**
   * 支付成功
   */
  SUCCESS = 1,
  /**
   * 还款失败
   */
  FAILED = 2,
  /**
   * 还款中
   */
  WAITING = 3,
  /**
   * 还款取消
   */
  CANCEL = 4,
  /**
   * 还款不存在
   */
  NOT_EXIST = 5,
  /**
   * 还款成功
   */
  REPAY_SUCCESS = 6,
  /**
   * 部分成功
   */
  PARTIAL_SUCCESS = 7,
}

/**
 * 品牌名称
 */
export const enum BrandTypes {
  YRXD = '宜人小贷',
  YXH = '宜享花',
}

/**
 * 提额渠道状态
 */
export const enum RaiseCreditLimitStatus {
  /**
   * 去完成
   */
  WAITING = 1,
  /**
   * 获取中
   */
  OBTAIN = 2,
  /**
   * 已完成
   */
  FINISHED = 3,
  /**
   * 获取失败/重新提交
   */
  OBTAIN_FAILED = 4,
  /**
   * 未通过
   */
  FAILED = 5,
  /**
   * 去更新
   */
  WAITING_UPDATE = 6,
  /**
   * 暂无法提额
   */
  REJECTED = 7,
  /**
   * 审核中
   */
  AUDIT = 8,
  /**
   * 审核失败
   */
  ADUIT_FAILED = 9,
  /**
   * 补充信息
   */
  SUPPLEMENTARY = 10,
  /**
   * 没有提额券需要跳转购买权益包页
   */
  NO_COUPONS = 11,
  /**
   * 逾期
   */
  EXPIRED = 12,
  /**
   * 去还款
   */
  REFUND = 13,
  /**
   * 继续申请
   */
  CONTINUE = 14,
  /**
   * 已完成，仅提示，不展示提额值
   */
  FINISHED_HINT = 15,
  /**
   * 企业主未认证状态
   */
  NOT_CERTIFIED = 16,
}

/**
 * 添加/更换卡类型
 */
export const enum BankcardTypes {
  /**
   * 放款卡
   * @type {Number}
   */
  LOAN = 1,
  /**
   * 划扣卡
   * @type {Number}
   */
  DEDUCTION = 2,
  /**
   * 还款卡
   * @type {Number}
   */
  REPAY = 3,
}

/**
 * 银行卡场景类型
 * 注意：它和银行卡类型不是一个概念
 */
export const enum BankcardSceneTypes {
  FALLBACK = 1,
}

/**
 * 补签红包发放机制类型
 */
export const enum SupCardSignMechanismTypes {
  /**
   * 后端已在 init 内自动发红包
   */
  PRE = 'PRE',
  /**
   * 前端在签约成功后调 /redeem 发红包
   */
  POST = 'POST',
}

/**
 * 进入下载页的流程处理类型
 */
export const enum DestTypes {
  /**
   * 登录后
   */
  AFTER_LOGIN = '1',
  /**
   * 无在还借款后
   */
  AFTER_NOT_LOAN = '2',
  /**
   * 授信后
   */
  AFTER_VERIFY = '3',
}

/**
 * 人脸识别位置
 */
export const enum FaceLocations {
  /**
   * 前置，即信审流程
   */
  FRONT = '0',
  /**
   * 后置，即借款流程
   */
  BACK = '1',
  /**
   * 补签流程
   */
  SIGNED = '2',
  /**
   * 修改手机号验证
   */
  CHANGE_PHONE = '5',
  /**
   * 消保-下载合同  预览下载合同
   */
  DOWNLOAD_CONTRACT = '6',
  /**
   * 广告主需要人脸
   */
  PARTNER = '7',
  /**
   * 优享提额需要人脸
   */
  PREFERRED_INCREASE = '8',
  /**
   * 进入查看合同页面需要人脸
   */
  ENTER_CONTRACT_FACE = '9',
  /**
   * 进入结清证明页面需要人脸
   */
  ENTER_SETTLEMENT_PROOF_FACE = '10',
  /**
   * 进入借款记录页面需要人脸
   */
  ENTER_LOAN_RECORD_FACE = '11',
  /**
   * 广告主车贷需要人脸
   */
  PARTNER_CAR_LOAN = '12',
  /**
   * CA还款换卡
   */
  REPAY_BANKCARD_CA = '13',
  /**
   * CA提额中心去提额
   */
  RAISE_CREDIT_LIMIT_CA = '14',
  /**
   * CA月卡
   */
  REPAY_MONTH_CARD_CA = '15',
  /**
   * CA广告主资金匹配页
   */
  PARTNER_FUND_MATCH_CA = '16',
  /**
   * 广告主-提现申请页
   */
  PARTNER_APPLY_CA = '17',
  /**
   * 广告主-资料补充页
   */
  PARTNER_APPLY_COMPLETE_CA = '18',
  /**
   * 广告主- 一次风控等待页 APP使用
   */
  PARTNER_APPLY_WAIT_CA = '19',
  /**
   * CA月卡落地页购买
   */
  BUY_MONTH_CARD_CA = '20',
  /**
   * 客诉承诺函补签协议
   */
  SUPPLEYMENTARY_CONTRACT = '22',
  /**
   * CA 落地页购买
   */
  COMPENSATE_CARD_LIDAI_NEW_BOUGHT = '23',
  /**
   * 小米代运营需要人脸
   */
  DYY_NEED_FACE_BLOCK = '34',
}

/**
 * 提额类型
 */
export const enum RaiseCreditLimitTypes {
  /**
   * 公积金
   */
  HOUSING_FUND = 0,
  /**
   * 工资流水
   */
  SALARY = 1,
}

/**
 * 还款类型
 */
export const enum RepaymentTypes {
  /**
   * 普通还款
   */
  REPAY = 0,
  /**
   * 提前结清
   */
  SETTLE_REPAY = 1,
}

/**
 * 身份证类型
 */
export const enum IdentityCardTypes {
  /**
   * 正面
   */
  FRONT = 0,
  /**
   * 反面
   */
  BACK = 1,
}

/**
 * 身份证流程类型
 */
export const enum IdentityCardFromTypes {
  /**
   * 授信
   */
  CREDIT = 0,
  /**
   * 借款
   */
  LOAN = 1,
  /**
   * 主页
   */
  HOME = 2,
  /**
   * 车抵贷
   */
  CAR_LOAN = 3,
  /**
   * 广告主增验
   */
  PARTNER_LOAN = 4,
  /**
   * 广告主增验
   */
  PARTNER_LOAN_RESULT = 5,
}

/*
 * 活动跳转类型
 */
export const enum ActivityJumpTypes {
  /**
   * 无跳转
   */
  NONE = 0,
  /**
   * 跳转URL地址
   */
  URL = 1,
  /**
   * 指定活动
   */
  ACTIVITY = 2,
  /**
   * 跳转到在线客服
   */
  ONLINE = 3,
}

/**
 * 抵扣金额类型
 */
export const enum EntrustDeductionAmountTypes {
  /**
   * 息费
   */
  INTEREST = 1,
  /**
   * 分期服务费
   */
  INSTALMENT_SERVICE_CHARGE = 2,
  /**
   * 担保服务费
   */
  GUARANTEE_SERVICE_CHARGE = 3,
}

/**
 * 借款类型
 */
export const enum LoanTypes {
  /**
   * 其他
   */
  OTHER = -1,
  /**
   * 现金分期
   */
  CASH = 0,
  /**
   * 购物分期
   */
  SHOPPING = 1,
  /**
   * 权益分期
   */
  RIGHTS_INTERESTS = 3,
  /**
   * 嘉盈
   */
  RD = 6,
}

export const LoanTypesMap = {
  [LoanTypes.CASH]: '现金分期',
  [LoanTypes.RIGHTS_INTERESTS]: '权益分期',
  [LoanTypes.SHOPPING]: '购物分期',
  [LoanTypes.OTHER]: '现金分期', // 定额定期
};

/**
 * 下载类型
 */
export const enum DownloadTypes {
  /**
   * 合同
   */
  LOAN_CONTRACT = 1,
  /**
   * 结清证明
   */
  SETTLEMENT_PROOF = 2,
}

/**
 * 下载类型文本映射
 */
export const DownloadTypesMap = {
  [DownloadTypes.LOAN_CONTRACT]: '合同',
  [DownloadTypes.SETTLEMENT_PROOF]: '结清证明',
};

/**
 * 产品期限单位类型
 */
export const enum ProductTermUnitTypes {
  /**
   * 期数
   */
  PERIOD = 0,
  /**
   * 天数
   */
  DAY = 1,
}

/**
 * 导流产品类型
 */
export const enum DiversionProductTypes {
  /**
   * 小贷产品
   */
  LOAN = 1,
  /**
   * 保险产品
   */
  INSURANCE = 2,
  /**
   * 大额导流产品
   */
  LARGE_LOAN = 3,
  /**
   * c类用户推荐产品
   */
  CUSTOMER_C = 4,
  /**
   * c类用户导航位产品,
   */
  CUSTOMER_C_NAV_PRODUCT = 6,
  /**
   * c面-高通过率,
   */
  CUSTOMER_C_HIGH_PASS_RATE = 7,
  /**
   * c面-低利率,
   */
  CUSTOMER_C_MIN_RATE = 8,
  /**
   * c面-高额度,
   */
  CUSTOMER_C_MAX_LIMIT = 9,
}

/*
 * API导流业务类型
 */
export const enum PartnerBizTypes {
  /**
   * 授信
   */
  CREDIT = 'credit',
  /**
   * 放款
   */
  LOAN = 'loan',
  /**
   * 还款
   */
  REPAY = 'repay',
  /**
   * 放款中
   */
  FUND_MATCH = 'fund_match',
}

/**
 * API导流卡列表变更模式
 */
export const enum PartnerChangeCardMode {
  /**
   * 新增模式
   */
  ADD = 1,
  /**
   * 更新模式
   */
  UPDATE = 0,
}

/**
 * API导流协议场景类型
 */
export const enum PartnerAgreementTypes {
  /**
   * 注册
   */
  REGISTER = 'REGISTER',
  /**
   * 贷前
   */
  PRE_LOAN = 'PRE_LOAN',
  /**
   * 授信
   */
  CREDIT = 'CREDIT',
  /**
   * 绑卡
   */
  BIND = 'BIND',
  /**
   * 借款
   */
  LOAN = 'LOAN',
}

/**
 * 合作方借款模式
 */
export const enum PartnerLoanTypes {
  /**
   * H5模式
   */
  H5 = 1,
  /**
   * API模式
   */
  API = 2,
  /**
   * SEMI_H5模式
   */
  SEMI_H5 = 3,
}

/**
 * 合作方还款模式
 */
export const enum PartnerRepayTypes {
  /**
   * H5模式
   */
  H5 = 1,
  /**
   * API模式
   */
  API = 2,
}

/**
 * 资源位场景类型
 */
export const enum ResourceSceneTypes {
  /**
   * 拒贷导流场景
   */
  REJECTED_RECOMMEND = 5,
  /**
   * 还款成功场景
   */
  REPAYMENT_SUCCESSFUL = 6,
  /**
   * 放款中场景
   */
  LOANING = 8,
  /**
   * 还款列表场景
   */
  REPAYMENT = 10,
  /**
   * 保险页Banner场景
   */
  INSURANCE_BANNER = 11,
  /**
   * 保险页产品场景
   */
  INSURANCE_PRODUCT = 12,
  /**
   * 贷超页Banner场景
   */
  LOAN_BANNER = 13,
  /**
   * 贷超页产品场景
   */
  LOAN_PRODUCT = 14,
  /**
   * c类用户金刚位
   */
  CUSTOMER_C_NAV = 19,
  /**
   * c类用户banner位
   */
  CUSTOMER_C_BANNER = 20,
  /**
   * 签到首页弹窗
   */
  SIGN_INDEX_POPUP = 21,
  /**
   * 签到首页专享福利
   */
  SIGN_INDEX_WELFARE_LIST = 22,
  /**
   * 签到详情
   */
  SIGN_DETAIL_BANNER = 23,
  /**
   * 权益订单详情底部banner位
   */
  VIP_ORDER_BANNER = 25,
  /**
   * 联系客服顶部banner位
   */
  CUSTOMER_SERVICE_BANNER = 28,
  /**
   * 联系客服快捷入口
   */
  CUSTOMER_FAST_ENTRANCE = 29,
  /**
   * 联系客服更多联系方式
   */
  CUSTOMER_MORE_WAY = 30,
  /**
   * 其他问题
   */
  CUSTOMER_ELSE_QUESTION = 37,
  /**
   * 享借卡-资金路由入口
   */
  XJK_FUND_ROUTING = 70,
  /**
   * 加速宝-挽留弹窗
   */
  ACCELERATOR_DETAINMENT = 72,
  /**
   * 借款排队页-banner
   */
  LOAN_QUEUE_BANNER = 73,
  /**
   * 借款页会员权益banner
   */
  LOAN_VIP_CARD_BANNER = 75,
  /**
   * 还款页会员权益banner
   */
  REPAY_VIP_CARD_BANNER = 76,
  /**
   * 省钱卡挽留弹窗
   */
  SAVE_MONEY_CARD_DETAINMENT = 79,
  /**
   * 省钱卡引导弹窗(未领取状态下)
   */
  SAVE_MONEY_CARD_GUIDE = 151,
  /**
   * 审核宝挽留弹窗
   */
  AUDIT_CARD_DETAINMENT = 82,
  /**
   * 冻结页banner
   */
  FROZEN_BANNER = 139,
  /**
   * 冻结页弹窗
   */
  FROZEN_POPUP = 81,
  /**
   * 无忧宝-中转页弹窗-中原消金
   */
  WORRYFREE_ENTERED_ZY = 140,
  /**
   * 无忧宝-挽留弹窗
   */
  WORRYFREE_DETAINMENT = 141,
  /**
   * 排队页-挽留弹窗
   */
  QUEUE_DETAINMENT = 142,
  /**
   * 重审卡-挽留弹窗
   */
  RETRIALCARD_DETAINMENT = 143,
  /**
   * 到账宝-挽留弹窗
   */
  GAINSCARD_DETAINMENT = 144,
  /**
   * 拒必退-弹窗
   */
  COMPENSATE_POPUP = 145,
  /**
   * 提额卡-挽留弹窗
   */
  RAISE_CREDIT_CARD_DETAINMENT = 88,
  /**
   * 出额宝-挽留弹窗
   */
  EXPORT_AMOUNT_DETAINMENT = 99,
  /**
   * 无忧宝-中转页弹窗-海尔
   */
  WORRYFREE_ENTERED_HE = 150,
  /**
   * 无忧宝-中转页弹窗-众邦h5
   */
  WORRYFREE_ENTERED_ZBH5 = 160,
  /**
   * 积分页面-卡券兑换banner
   */
  POINTS_COUPON = 120,
  /**
   * 积分页面-实物兑换banner
   */
  POINTS_ENTITY = 121,
  /**
   * 积分页面-大转盘
   */
  LUCKWHEEL = 125,
  /**
   * 放款结果页-加速包加速放款
   */
  JSB_LOAN_RESULT = 205,
  /**
   * API放款页保险banner
   */
  API_LOAN_RESULT = 206,
  /**
   * 借款页营销资源
   */
  LOAN_BACK_MARKETING = 218,
  /**
   * 提额降息-保险入口浮动气泡
   */
  BXSC_FLOAT_BUBBLE = 223,
  /**
   * 积分签到页面banner
   */
  POINTS_SIGN_IN_BANNER = 225,
  /**
   * 积分成就中心页面banner
   */
  POINTS_ACHIEVEMENT_BANNER = 226,
  /**
   * 额度冻结页-保险banner
   */
  FROZEN_PAGE_BANNER = 232,
  /**
   * 授信拒绝页-保险banner
   */
  DENY_PAGE_BANNER = 233,
  /**
   * 额度冻结页-保险弹窗
   */
  FROZEN_RETAIN_POPUP = 236,
  /**
   * 借款结果页-保险弹窗
   */
  LOAN_RESULT_RETAIN_POPUP = 234,
  /**
   * API借款结果页-保险弹窗
   */
  PARTNER_LOAN_RESULT_RETAIN_POPUP = 235,
  /**
   * 借款排队页-保险banner
   */
  JSB_LINE_UP_INSURANCE_BANNER = 237,
  /**
   * 借款排队页-保险挽留弹窗
   */
  JSB_LINE_UP_INSURANCE_RETAIN_POPUP = 238,
  /**
   * 悦享借页-保险挽留弹窗
   */
  COMPENSATE_CARD_POPUP = 254,
  /**
   * 匹配资金页-保险挽留弹窗
   */
  LOAN_WAITING_POPUP = 255,
  /**
   * 还款成功页-保险挽留弹窗
   */
  REPAY_SUCCESS_POPUP = 256,
  /**
   * 还款记录页-保险挽留弹窗
   */
  REPAY_RECORD_POPUP = 257,
  /**
   * 速通卡支付成功页-保险挽留弹窗
   */
  STK_PAY_SUCCESS_POPUP = 258,
  /**
   * 跃升服务-详情页-返回-挽留弹窗
   */
  UPGRADE_CARD_RETENTION_POPUP = 319,
  /**
   * 跃升服务-资金匹配页弹窗
   */
  UPGRADE_CARD_POPUP = 320,
  /**
   * 跃升服务-跃升卡详情页-挽留弹窗-先享后付
   */
  UPGRADE_CARD_PAY_LATER_POPUP = 321,
  /**
   * 跃升服务-评估页-跃升卡挽留弹窗
   */
  UPGRADE_CARD_ASSESSMENT_POPUP = 322,
  /**
   * 银行卡页-banner
   */
  BANK_LIST_PAGE_BANNER = 323,
  /**
   * 账单详情页-banner
   */
  REPAYMENT_SCHEDULE_PAGE_BANNER = 318,
  /**
   * 借款记录页-banner
   */
  LOAN_RECORD_PAGE_BANNER = 315,
  /**
   * 结清证明页-banner
   */
  COMPLETED_PROVE_PAGE_BANNER = 299,
  /**
   * 查看合同页-banner
   */
  CONTRACT_PAGE_BANNER = 288,
  /**
   * 钱包页面-banner
   */
  USER_WALLET_PAGE_BANNER = 296,
  /**
   * 还款记录页-banner
   */
  REPAY_RECORD_PAGE_BANNER = 282,
  /**
   * 授信审核拒绝页-第一个banner位
   */
  ASSESSMENT_DENY_PAGE_BANNER_FIRST = 338,
  /**
   * 授信审核拒绝页-第二个banner位
   */
  ASSESSMENT_DENY_PAGE_BANNER_SECOND = 339,
  /**
   * 授信审核拒绝页-第三个banner位
   */
  ASSESSMENT_DENY_PAGE_BANNER_THIRD = 340,
  /**
   * 提现拒绝资金匹配页-第一个banner位
   */
  WITHDRAW_DENY_PAGE_BANNER_PLATE_FIRST = 343,
  /**
   * 提现拒绝资金匹配页-第二个banner位
   */
  WITHDRAW_DENY_PAGE_BANNER_PLATE_SECOND = 344,
  /**
   * 提现拒绝资金匹配页-第三个banner位
   */
  WITHDRAW_DENY_PAGE_BANNER_PLATE_THIRD = 345,
  /**
   * H5 C 面导流产品页挽留弹窗
   */
  // H5C_RETAINMENT = 395,
  /**
   * 导流授信页-挽留弹窗
   */
  PARTNER_LOAN_APPLY_RETAINMENT = 396,
  /**
   * 导流提现页-挽留弹窗
   */
  PARTNER_LOAN_RETAINMENT = 397,
  /**
   * 导流h5页-挽留弹窗
   */
  H5C_RETAINMENT = 398,
  /**
   * 消息中心-挽留弹窗
   */
  MESSAGE_CENTER_RETAINMENT = 399,
  /**
   * 还款记录挽留弹窗类型
   */
  REPAY_RECORD_PAGE_DETAINMENT = 404,
  /**
   * 借款记录挽留弹窗类型
   */
  LOAN_RECORD_PAGE_DETAINMENT = 403,
  /**
   * 资金匹配页挽留弹窗类型
   */
  LOAN_FUND_PAGE_DETAINMENT = 402,
  /**
   * 资金匹配页跃升卡挽留弹窗
   */
  IMPROVE_CARD_EVAL_RETAIN_POPUP = 328,
}

export const ResourceSceneTypesIndexMap: Partial<Record<ResourceSceneTypes, string>> = {
  [ResourceSceneTypes.ASSESSMENT_DENY_PAGE_BANNER_FIRST]: '一',
  [ResourceSceneTypes.ASSESSMENT_DENY_PAGE_BANNER_SECOND]: '二',
  [ResourceSceneTypes.ASSESSMENT_DENY_PAGE_BANNER_THIRD]: '三',
  [ResourceSceneTypes.WITHDRAW_DENY_PAGE_BANNER_PLATE_FIRST]: '一',
  [ResourceSceneTypes.WITHDRAW_DENY_PAGE_BANNER_PLATE_SECOND]: '二',
  [ResourceSceneTypes.WITHDRAW_DENY_PAGE_BANNER_PLATE_THIRD]: '三',
};

/**
 * 联系客服-问题资源位类型
 */
export const enum ResourceQestionTypes {
  /**
   * 借款问题
   */
  QUESTION_LOAN = 1,
  /**
   * 还款问题
   */
  QUESTION_REPLAY = 2,
}

/**
 * 打开链接方式
 */
export const enum OpenURLMode {
  /**
   * WebView
   */
  WEBVIEW = 1,
  /**
   * 浏览器
   */
  BROWSER = 2,
}

/*
 * 账单类型
 */
export const enum BillTypes {
  /**
   * 还款返现
   */
  REPAYMENT_CASHBACK = 1,
  /**
   * 息费返现
   */
  INTEREST_CASHBACK = 2,
  /**
   * 提现
   */
  WITHDRAW = 3,
  /**
   * 退票
   */
  REFUND = 4,
  /**
   * 营销返现
   */
  MARKETING_CASHBACK = 5,
  /**
   * MGM赏金
   */
  MGM_BOUNTY = 7,
}

/**
 * 卡券来源类型
 */
export const enum CouponSourceTypes {
  /**
   * 营销
   */
  MARKETING = 1,
  /**
   * vip卡
   */
  VIP_CARD = 2,
  /**
   * 分期权益包
   */
  RIGHTS_INTERESTS = 3,
  /**
   * 客户安抚礼包
   */
  COMFORT_COUPON_PACK = 26,
}

/**
 * 卡券类型
 */
export const enum CouponTypes {
  /**
   * 还款红包
   */
  REPAY_RED_PACKET = 0,
  /**
   * 借款折扣券
   */
  LOAN_DISCOUNT = 1,
  /**
   * 还款返现券（区分灵活定价和非定价，但type相同，开发时需注意是否需要通过其他字段区分）
   */
  REPAY_CASH_BACK = 2,
  /**
   * 主动提额券
   */
  RAISE_CREDIT_LIMIT = 3,
  /**
   * 权益卡代金券
   */
  RIGHTSCARD_COUPONS = 13,
  /**
   * 提款返现券
   */
  LOAN_CASH_BACK = 8,
  /**
   * 广告主提现红包
   */
  PARTNER_RED_PACKET = 33,
  /**
   * 还款随机返现券
   */
  REPAY_RANDOM_CASH_BACK = 38,
  /**
   * 0息借款券
   */
  ZERO_INTEREST_LOAN_COUPON = 51,
  /**
   * 还款福利金
   */
  REPAY_HKFLJ = 52,
  /**
   * 随借随还券
   */
  ANYTIME_REPAY_COUPON = 53,
  /**
   * 定价券(息费减免券)
   */
  PRICING_COUPON = 55,
  /**
   * 免息券
   */
  DISCOUNT_COUPON = 59,
  /**
   * 借款提额券
   */
  LOAN_RAISE_CREDIT_LIMIT_COUPON = 60,
  /**
   * 分期折扣券
   */
  FENQI_ZHEKOU_COUPON = 61,
  /**
   * 分期立减券
   */
  FENQI_LIJIAN_COUPON = 62,
}

/**
 * 卡券类型文本映射
 */
export const CouponTypesMap = {
  [CouponTypes.LOAN_DISCOUNT]: '借款折扣券',
  [CouponTypes.REPAY_CASH_BACK]: '还款返现券',
  [CouponTypes.RAISE_CREDIT_LIMIT]: '主动提额券',
  [CouponTypes.REPAY_RED_PACKET]: '还款红包',
  [CouponTypes.RIGHTSCARD_COUPONS]: '权益卡代金券',
  [CouponTypes.LOAN_CASH_BACK]: '提款返现券',
  [CouponTypes.PARTNER_RED_PACKET]: '借款红包',
  [CouponTypes.REPAY_RANDOM_CASH_BACK]: '还款随机返现券',
  [CouponTypes.ZERO_INTEREST_LOAN_COUPON]: '0息借款券',
  [CouponTypes.REPAY_HKFLJ]: '还款福利金',
  [CouponTypes.ANYTIME_REPAY_COUPON]: '随借随还券',
  [CouponTypes.PRICING_COUPON]: '息费减免券',
  [CouponTypes.FENQI_ZHEKOU_COUPON]: '分期折扣券',
  [CouponTypes.FENQI_LIJIAN_COUPON]: '分期立减券',
};

/**
 * 通知支付产品类型
 */
export const enum NotifyPaymentProductTypes {
  /**
   * PASS卡
   */
  PASS_CARD = 1,
  /**
   * 审核宝
   */
  AUDIT_CARD = 2,
  /**
   * 出额宝
   */
  EXPORT_AMOUNT_CARD = 3,
}

/**
 * 通知支付状态
 */
export const enum NotifyPaymentStatus {
  /**
   * 成功
   */
  SUCCESS = 1,
  /**
   * 失败
   */
  FAILED = 2,
  /**
   * 取消
   */
  CANCEL = 3,
}

/**
 * 通知loading文案
 */
export const enum NotifyPaymentText {
  /**
   * 重审卡
   */
  RETRIALCARD = '权益',
  /**
   * pass卡
   */
  PASSCARD = 'PASS卡',
  /**
   * 审核宝
   */
  AUDIT_CARD = '审核宝',
  /**
   * 出额宝
   */
  EXPORT_AMOUNT_CARD = '出额宝',
}

/**
 * 信用报告-风控提额结果
 */
export const enum CreditReportRaiseLimitResult {
  /**
   * 提额=0
   */
  RAISE_FAIL = 0,
  /**
   * 提额成功
   */
  SUCCESS = 1,
  /**
   * 提额失败
   */
  FAILED = 2,
  /**
   * 无结果
   */
  PENDING = 3,
}

/**
 * 信用报告-保存结果
 */
export const enum SaveCreditReportResult {
  /**
   * 非提大额营销位
   */
  SAVE_SUCCESS = 0,
  /**
   * 大额营销位-不可以风控提额：30天内有收入版提额成功记录/30天内提额=0元
   */
  NOTRAISE = 1,
  /**
   * 大额营销位-可以风控提额：30天内无收入版提额成功记录&30天捏无提额=0
   */
  RAISED = 2,
}

/**
 * 消息内容类型
 */
export enum NoticeTypes {
  /**
   * 购买成功 审核成功
   */
  BUY_PASS = 2,
  /**
   * 成功借款
   */
  BORROW_PASS = 1,
  /**
   * 成功购买拒必退卡
   */
  COMPENSATE_CARD = 3,
  /**
   * MGM
   */
  MGM = 4,
  /**
   * 享借卡
   */
  COMFORT_CARD = 5,
}

/**
 * 微信支付状态
 */
export const enum WeChatPaymentStatus {
  /**
   * 未安装微信
   * 由于未安装微信，因此该状态非小程序返回，而是由App直接回调返回的状态
   */
  NOT_INSTALLED = '1000',
  /**
   * 支付成功
   */
  SUCCESS = '2000',
  /**
   * 支付中
   */
  WAITING = '3000',
  /**
   * 支付失败
   */
  FAIL = '9999',
  /**
   * 参数无效
   */
  INVALID = '4000',
  /**
   * 取消支付
   */
  CANCEL = '4001',
  /**
   * 未知错误
   */
  UNKNOWN = '5000',
  /**
   * 支付结果未知
   */
  RESULT_UNKNOWN = '6000',
}

/**
 * 支付宝支付状态
 */
export const enum AlipayPaymentStatus {
  /**
   * 支付处理中
   */
  PROCESSING = '8000',
  /**
   * 支付成功
   */
  SUCCESS = '9000',
  /**
   * 支付失败
   */
  FAIL = '4000',
  /**
   * 重复请求
   */
  REPEAT = '5000',
  /**
   * 取消支付
   */
  CANCEL = '6001',
  /**
   * 网络连接出错
   */
  NETWORK_ERROR = '6002',
  /**
   * 支付结果未知
   */
  RESULT_UNKNOWN = '6004',
}

/**
 * 支付结果状态
 */
export const enum PaymentResultStatus {
  /**
   * 待支付
   */
  UNPAID = 0,
  /**
   * 支付中
   */
  PAYING = 1,
  /**
   * 支付成功
   */
  PAYMENT_SUCCESS = 2,
  /**
   * 支付失败
   */
  PAYMENT_FAIL = 3,
  /**
   * 已退款
   */
  REFUNDED = 4,
}

/**
 * 微信小程序类型
 */
export const enum WeChatMiniProgramTypes {
  /**
   * 正式版
   */
  RELEASE = '0',
  /**
   * 开发版
   */
  DEVELOP = '1',
  /**
   * 体验版
   */
  TRIAL = '2',
}

/**
 * 宜享生活微信小程序原始ID
 */
export const YS_WECHAT_MP_ID = 'gh_96a9e99df4fa';

/**
 * 众帮生活微信小程序原始ID
 */
export const ZB_WECHAT_MP_ID = 'gh_13802a56ecf2';

// 默认微信小程序版本为正式版
let weChatMiniProgramType = WeChatMiniProgramTypes.RELEASE;

// 测试环境或指定了体验版环境时使用微信小程序体验版
if (
  process.env.VUE_APP_RUNTIME_ENV === 'testing' ||
  process.env.VUE_APP_MINI_PROGRAM_ENV === 'trial'
) {
  weChatMiniProgramType = WeChatMiniProgramTypes.TRIAL;
  // 开发环境微信小程序开发版
} else if (process.env.NODE_ENV === 'development') {
  weChatMiniProgramType = WeChatMiniProgramTypes.DEVELOP;
}

/**
 * 微信小程序版本类型
 */
export const WECHAT_MINI_PROGRAM_TYPE = weChatMiniProgramType;

/**
 * 支付类型
 */
export const enum PayTypes {
  /**
   * 支付宝支付(APP)
   */
  ALI_PAY = '1',
  /**
   * 支付宝支付(H5)
   */
  ALI_PAY_H5 = '5',
  /**
   * 银行卡支付
   */
  BANKCARD_PAY = '4',
  /**
   * 微信支付
   */
  WECHAT_PAY = '2',
}

/**
 * 支付类型文本映射
 */
export const PayTypesMap = {
  [PayTypes.ALI_PAY]: '支付宝支付',
  [PayTypes.ALI_PAY_H5]: '支付宝支付',
  [PayTypes.BANKCARD_PAY]: '银行卡支付',
  [PayTypes.WECHAT_PAY]: '微信支付',
};

/**
 * 商品类型
 */
export const enum GoodsTypes {
  /**
   * 会员季卡
   */
  VIP_QUARTER_CARD = 1,
  /**
   * 会员年卡
   */
  VIP_ANNUAL_CARD = 2,
  /**
   * 会员年卡PLUS
   */
  // VIP_ANNUAL_PLUS_CARD = 7,
  /**
   * PASS卡
   */
  // PASS_CARD = 3,
  /**
   * 提额卡
   */
  // RAISE_CREDIT_LIMIT_CARD = 8,
  /**
   * 享借卡
   */
  COMFORT_CARD = 10,
  /**
   * 到账宝
   */
  // DZB_CARD = 11,
  /**
   * 加速宝
   */
  ACCELERATOR = 12,
  /**
   * 悦享借卡（原拒必退卡）
   */
  COMPENSATE_CARD = 13,
  /**
   * 省钱卡
   */
  SAVE_MONEY_CARD = 14,
  /**
   * 审核宝
   */
  // AUDIT_CARD = 15,
  /**
   * 无忧宝
   */
  // WORRYFREE = 16,
  /**
   * 还款宝
   */
  REPAYMENT_CARD = 17,
  /**
   * 出额宝
   */
  // EXPORT_AMOUNT_CARD = 18,
  /**
   * 会员季卡新
   */
  VIP_QUARTER_CARD_V2 = 19,
  /**
   * 会员年卡新
   */
  VIP_ANNUAL_CARD_V2 = 20,
  /**
   *解锁卡
   *
   */
  // UNLOCK_CARD = 25,
  /**
   * 履约宝
   */
  // HONOUR_AGREEMENT_CARD = 27,
  /**
   * 生活月卡
   */
  LIFE_MONTH_CARD = 29,
  /**
   * 会员月卡
   */
  VIP_MONTH_CARD = 30,
  /**
   * 会员尊享月卡
   */
  SVIP_MONTH_CARD = 31,

  /**
   * 会员月卡多档位
   */
  VIP_MONTH_CARD_MULTI_PRICE = 41,

  /**
   * 还款福利金
   */
  REPAY_WELFARE = 32,
  /**
   * 还款福利计划
   */
  HKFL_WELFARE_PLAN = 34,
  /**
   * 速通卡
   */
  FAST_PASS_CARD = 35,
  /**
   * 砺带悦享借
   */
  COMPENSATE_CARD_LD = 37,
  /**
   * 新提额卡
   */
  NEW_RAISE_CREDIT_LIMIT_CARD = 39,
  /**
   * 跃升服务
   */
  UPGRADE_CARD = 40,
  /**
   * 砺带还款宝
   */
  LIDA_REPAYMENT_CARD = 42,
}

/**
 * 商品类型文本映射
 */
export const GoodsTypesMap: Record<GoodsTypes, string> = {
  [GoodsTypes.VIP_QUARTER_CARD]: 'VIP超值卡·季卡',
  [GoodsTypes.VIP_ANNUAL_CARD]: 'VIP超值卡·年卡',
  [GoodsTypes.VIP_QUARTER_CARD_V2]: 'VIP超值卡·季卡',
  [GoodsTypes.VIP_ANNUAL_CARD_V2]: 'VIP超值卡·年卡',
  // [GoodsTypes.VIP_ANNUAL_PLUS_CARD]: 'VIP超值卡·年卡PLUS',
  [GoodsTypes.ACCELERATOR]: '加速宝',
  [GoodsTypes.COMPENSATE_CARD]: '悦享借',
  [GoodsTypes.SAVE_MONEY_CARD]: '省钱卡',
  // [GoodsTypes.AUDIT_CARD]: '审核宝',
  // [GoodsTypes.WORRYFREE]: '无忧宝',
  [GoodsTypes.REPAYMENT_CARD]: '还款宝',
  [GoodsTypes.COMFORT_CARD]: '享借卡',
  // [GoodsTypes.DZB_CARD]: '到账宝',
  // [GoodsTypes.RAISE_CREDIT_LIMIT_CARD]: '提额卡',
  // [GoodsTypes.PASS_CARD]: '提额卡',
  // [GoodsTypes.EXPORT_AMOUNT_CARD]: '出额宝',
  // [GoodsTypes.UNLOCK_CARD]: '解锁卡',
  // [GoodsTypes.HONOUR_AGREEMENT_CARD]: '返现特权', //履约宝
  [GoodsTypes.LIFE_MONTH_CARD]: '生活月卡',
  [GoodsTypes.VIP_MONTH_CARD]: '会员月卡', // 文本展示为臻选计划，但是埋点也用所以不调整只在文本展示处特殊处理
  [GoodsTypes.SVIP_MONTH_CARD]: '会员尊享月卡', // 文本展示为尊享臻选计划，但是埋点也用所以不调整只在文本展示处特殊处理
  [GoodsTypes.REPAY_WELFARE]: '还款福利金',
  [GoodsTypes.HKFL_WELFARE_PLAN]: '还款福利计划',
  [GoodsTypes.FAST_PASS_CARD]: '速通卡',
  [GoodsTypes.COMPENSATE_CARD_LD]: '悦享借', // 砺带版本悦享借
  [GoodsTypes.NEW_RAISE_CREDIT_LIMIT_CARD]: '提额卡',
  [GoodsTypes.UPGRADE_CARD]: '跃升服务',
  [GoodsTypes.VIP_MONTH_CARD_MULTI_PRICE]: '会员月卡',
  [GoodsTypes.LIDA_REPAYMENT_CARD]: '还款宝',
};

/** 权益类型 */
export enum ZxEquityTypes {
  /** 会员额度 */
  MEMBER_QUOTA = 1,
  /** 专属提现通道 */
  EXCLUSIVE_WITHDRAW_CHANNEL = 2,
  /** 提现折扣券 */
  WITHDRAW_DISCOUNT_COUPON = 3,
  /** 还款返现券 */
  REPAY_CASHBACK_COUPON = 4,
  /** 美团券包 */
  MEITUAN_COUPON_PACK = 5,
  /** 声盎权益 */
  SHENGANG_EQUITY = 6,
  /** 砺带权益 */
  LIDAI_EQUITY = 7,
}

/**
 * 支付商户
 */
export enum PaymentMerchant {
  /**
   * 优赛
   */
  YS = '0',
  /**
   * 众帮
   */
  ZB = '1',
}

/**
 * 权益订单状态（聚合后新的）
 */
export const enum OrderStatusNew {
  UNPAID = 1, //待支付
  CANCELED = 2, //已取消
  PAID = 3, // 支付成功
  PART_SUCCESS = 4, // 部分成功
  REFUNDED = 5, // 已退款
  PART_REFUNDED = 6, // 部分退款
}

/**
 * 权益订单状态
 */

export const enum OrderStatus {
  UNPAID = 1,
  PAID = 2,
  REFUNDING = 4,
  REFUNDED = 5,
  REFUND_FAILED = 6,
  REFUNDED_TO_WALLET = 7,
  CANCELED = 8,
  REFUNDED_TO_BANKCARD = 9,
}
/**
 * 订单状态文本映射
 */
export const OrderStatusMap = {
  [OrderStatus.UNPAID]: '待支付',
  [OrderStatus.PAID]: '已支付',
  [OrderStatus.REFUNDING]: '退款中',
  [OrderStatus.REFUNDED]: '已退款',
  [OrderStatus.REFUND_FAILED]: '退款失败',
  [OrderStatus.REFUNDED_TO_WALLET]: '钱包退款成功',
  [OrderStatus.CANCELED]: '已取消',
  [OrderStatus.REFUNDED_TO_BANKCARD]: '银行卡退款成功',
};

/**
 * 权益有效状态
 */
export const enum EffectiveStatus {
  /**
   * 无效
   */
  LOSE_EFFICACY = 0,
  /**
   * 有效
   */
  EFFICACY = 1,
}

/**
 * 砺带还款宝权益行权状态
 */
export const enum LidaRepaymentCardExerciseStatus {
  /**
   * 未开放
   */
  NOT_OPEN = 0,
  /**
   * 去使用
   */
  TO_USE = 1,
  /**
   * 已失效
   */
  LOSE_EFFICACY = 2,
}

/**
 * 权益状态文案映射
 */
export const EffectiveStatusMap: Record<EffectiveStatus, string> = {
  [EffectiveStatus.EFFICACY]: '有效',
  [EffectiveStatus.LOSE_EFFICACY]: '无效',
};

/**
 * 权益行权状态
 */
export const enum ExerciseStatus {
  /**
   * 行权成功
   */
  SUCCESS = 0,
  /**
   * 行权中
   */
  EXERCISING = 1,
  /**
   * 银行卡失败
   */
  BANKCARD_FAILED = 2,
  /**
   * 行权失败
   */
  FAILED = 3,
  /**
   * 未使用不可退款 拒必退
   */
  NON_REFUNDABLE = 4,
  /**
   * 未使用可退款 拒必退
   */
  REFUNDABLE = 5,
  /**
   * 当日不可取消订单 会员月卡
   */
  NOT_CANCEL_SUPPLEMENT = 6,
}

/**
 * 权益行权状态文案映射
 */
export const ExerciseStatusMap: Partial<Record<ExerciseStatus, string>> = {
  /**
   * 行权成功
   */
  [ExerciseStatus.SUCCESS]: '行权成功',
  /**
   * 行权失败
   */
  [ExerciseStatus.FAILED]: '行权失败',
};

/**
 * 还款宝权益领取状态
 */
export const enum RepaymentInterestsStatus {
  /**
   * 待领取
   */
  AWAIT_DRAW = 0,
  /**
   * 可领取
   */
  CAN_DRAW = 1,
  /**
   * 已领取
   */
  AlREADY_DRAW = 2,
  /**
   * 已失效
   */
  LOSE_EFFICACY = 3,
}

/**
 * 还款宝权益领取状态文案映射
 */
export const RepaymentInterestsStatusMap = {
  /**
   * 待领取
   */
  [RepaymentInterestsStatus.AWAIT_DRAW]: '待领取',
  /**
   * 可领取
   */
  [RepaymentInterestsStatus.CAN_DRAW]: '领取',
  /**
   * 已领取
   */
  [RepaymentInterestsStatus.AlREADY_DRAW]: '已领取',
  /**
   * 已失效
   */
  [RepaymentInterestsStatus.LOSE_EFFICACY]: '已失效',
};

/**
 * OCR/人脸识别厂商
 */
export const enum VerificationVendor {
  /**
   * 腾讯云
   */
  TENCENT_CLOUD = 1,
  /**
   * 旷视Face++
   */
  FACE_PLUS_PLUS = 2,
}

export const YXH_APP_PROTOCOL = 'yixianghua://';

/**
 * 路由成功后跳转流程
 */
export const enum RouteJumpProcess {
  /**
   * 小贷
   */
  XD = 1,
  /**
   * 跳转资方页面
   */
  EXTERNAL = 2,
}

/**
 * 到账宝支付结果状态
 */
export const enum DzbStatus {
  /**
   * 未支付
   */
  NOT_PAID = 0,
  /**
   * 已支付
   */
  PAID = 1,
  /**
   * 已使用
   */
  USED = 2,
}

/**
 * 提现结果状态
 */
export const enum WithdrawStatus {
  /**
   * 放款审核中
   */
  AUDIT = 0,
  /**
   * 审核成功
   */
  SUCCESS = 1,
  /**
   * 审核拒绝（欺诈）
   */
  REJECTED_FRAUD = 2,
  /**
   * 审核拒绝（其他）
   */
  REJECTED_OTHER = 3,
}

/**
 * 拒必退页面代金券弹窗类型
 */
export const enum JbtCouponsPopupTypes {
  /**
   * 未发生交易点击回退提示赠券
   */
  BACK = 1,
  /**
   * 批量发券的客户进入拒必退提示赠券，仅提示一次
   */
  BATCH_SENDCOUPONS_ENTRY = 2,
  /**
   * 非首次进入且有可用代金券，客户未支付点回退提示有券未使用
   */
  HAS_COUPONS_BACK = 3,
  /**
   * 可用代金券有效时间不足24小时，提示有券未使用
   */
  HAS_COUPONS_NOT24 = 4,
}

/**
 * 重审卡状态
 */
export enum RetrialCardStatus {
  /**
   * 可申请
   */
  QUALIFY = 0,
  /**
   * 本月购买已达上限
   */
  UPPER_LIMIT = 1,
  /**
   * 不符合申请资格
   */
  NO_QUALIFY = 2,
}

/**
 * 借款协议页面还款计划弹窗类型
 */
export const enum RepaymentPlanPopupTypes {
  PRICE_CHANGE = 1,
  XYXJ = 2,
  MSXJ = 3, //蒙商消金
  CAYH = 4, //长安银行
}

/**
 * 还款列表卡片状态
 */
export const enum RepayCardStatus {
  /**
   * 待还
   */
  UNPAID = '0',
  /**
   * 逾期
   */
  OVERDUE = '1',
  /**
   * 结清
   */
  SETTLEMENT = '2',
}

/**
 * 借款记录类型
 */
export const enum LoanRecordTypes {
  /**
   * 默认类型，宜享花
   */
  NORMAL = 0,
  /**
   * 合作方
   */
  PARTNER = 1,
}

/**
 * 借款记录状态
 */
export const enum LoanRecordStatus {
  /**
   * 放款中
   */
  LOANING = 20,
  /**
   * 还款中
   */
  REPAYING = 30,
  /**
   * 逾期
   */
  OVERDUE = 31,
  /**
   * 已结清
   */
  SETTLED = 40,
  /**
   * 已债转
   */
  DEBT_TRANSFERRED = 45,
  /**
   * 已失效
   */
  INVALID = 50,
}

/**
 * 还款记录中的还款状态
 */
export const enum RepayRecordStatus {
  /**
   * 还款成功
   */
  SUCCESS = '1',
  /**
   * 还款失败
   */
  FAILED = '2',
  /**
   * 还款中
   */
  WAITING = '3',
}

/**
 * 还款记录中的还款状态文本映射
 */
export const RepayRecordStatusMap = {
  [RepayRecordStatus.SUCCESS]: '还款成功',
  [RepayRecordStatus.FAILED]: '还款失败',
  [RepayRecordStatus.WAITING]: '还款处理中',
};

/**
 * 拒必退
 */
export enum JbtOrderStatus {
  /**
   * 未结算
   */
  UNPAID = 0,
  /**
   * 已结算
   */
  COMPLETE = 1,
}

/**
 * 订单-拒必退结算状态文本映射
 */
export const JbtOrderStatusMap = {
  [JbtOrderStatus.UNPAID]: '未结算',
  [JbtOrderStatus.COMPLETE]: '已结算',
};

/**
 * 发票类型
 */
export const enum InvoiceTypes {
  CASH = 1,
  RIGHTS = 2,
  ORDER = 3,
}

/**
 * 绑卡页入口来源
 */
export enum QuickBindBankcardEntryTypes {
  /**
   * 提现
   */
  LOAN = 0,
  /**
   * 还款
   */
  REPAY = 1,
  /**
   * 银行卡中心
   */
  CENTER = 2,
  /**
   * 钱包
   */
  WALLET = 3,
  /**
   * 还款详情-设置划扣卡
   */
  REPAY_DETAIL = 4,
  /**
   * 贷前绑卡-app
   */
  PRE_LOAN = 5,
  /**
   *  提额绑卡-app
   */
  RAISE = 6,
  /**
   * 匹配资金
   */
  WATING_FUND = 7,
}
/**
 * 绑卡页入口来源文案映射
 */
export const QuickBindBankcardEntryTypesMap = {
  [QuickBindBankcardEntryTypes.LOAN]: '提现',
  [QuickBindBankcardEntryTypes.REPAY]: '还款',
  [QuickBindBankcardEntryTypes.CENTER]: '银行卡中心',
  [QuickBindBankcardEntryTypes.WALLET]: '钱包',
  [QuickBindBankcardEntryTypes.REPAY_DETAIL]: '还款详情',
  [QuickBindBankcardEntryTypes.PRE_LOAN]: '贷前绑卡',
  [QuickBindBankcardEntryTypes.RAISE]: '提额绑卡',
  [QuickBindBankcardEntryTypes.WATING_FUND]: '匹配资金',
};

/**
 * 一键绑卡结果
 */
export enum QuickBindBankcardResultStatus {
  /**
   * 处理中
   */
  PENDING = 0,
  /**
   * 成功
   */
  SUCCESS = 1,
  /**
   * 失败
   */
  FAILED = 2,
  /**
   * 银行卡四要素鉴权没过需要填写手机号
   */
  NEED_PHONE = 3,
}

/**
 * 二次风控拒贷标签
 */
export enum DenyPageStatus {
  /**
   * 到账宝
   */
  DZB = 0,
  /**
   * 拒必退
   */
  JBT = 1,
  /**
   * 广告主（进入首页）
   */
  PARTNER = 2,
  /**
   * 广告主提现申请
   */
  PARTNER_APPLY = 3,
  /**
   * 广告主提现确认
   */
  PARTNER_LOAN = 4,
  /**
   * 天下信用
   */
  TXXY = 5,
  /**
   * 广告主授信中
   */
  PARTNER_ASSESSMENT = 6,
  /**
   * 广告主放款结果
   */
  PARTNER_RESULT = 7,
  /**
   * 广告主压单排队页
   */
  PARTNER_QUEUE = 8,
}

/**
 * 广告主绑卡方式
 */
export enum PartnerBindCardTypes {
  /**
   * H5
   */
  H5 = 1,
  /**
   * api
   */
  API = 2,
}

/**
 * 广告主绑卡方式
 */
export enum PartnerStatus {
  /**
   * 授信中
   */
  CREDITING = '60',
  /**
   * 授信成功
   */
  CREDITSUCCESS = '70',
  /**
   * 放款中
   */
  LENDING = '90',
}

/**
 * 额度中心-提额类型
 */
export enum AddAmountTypes {
  /**
   * 提额券
   */
  CREDIT_LIMIT_COUPONS = 2,
  /**
   * 天下信用报告提额(个人财富认证、车主专享提额、学历认证享提额)
   */
  TXXY = 3,
  /**
   * 个税提额
   */
  PERSONAL_TAX = 7,
  /**
   * 学历提额
   */
  EDUCATION = 8,
  /**
   * 商通贷提额
   */
  STD = 11,
  /**
   * 工资提额
   */
  SALARY = 12,
  /**
   * 企业主提额
   */
  BUSINESS_OWNER = 13,
  /**
   * 公积金提额
   */
  GJJ = 14,
  /**
   * 小小微-税票提额
   */
  TAX = 35,
  /**
   * 发票提额
   */
  INVOICE = 37,
  /**
   * 权益卡类提额
   */
  INTERESTS_CARD = 36,
  /**
   * 小微专利提额
   */
  ENTERPRISE_PATENT = 54,
  /**
   * 小微个人车辆提额
   */
  ENTERPRISE_CAR = 55,
  /**
   * 小微招投标提额
   */
  ENTERPRISE_BIDDING = 56,

  /**
   * 个体工商户
   */
  ENTERPRISE_INDIVIDUAL_BUSINESS = 61,
  /**
   * 商标提额
   */
  ENTERPRISE_TRADEMARK = 62,
  /**
   * 海关进出口提额
   */
  ENTERPRISE_CUSTOMS = 63,
  /**
   * 著作权提额
   */
  ENTERPRISE_COPYRIGHT = 64,
  /**
   * 电商商户
   */
  ENTERPRISE_ONLINE_BUSINESS = 68,
  /**
   * 广告主
   */
  ENTERPRISE_PARTNER = 72,
  /**
   * 优享提额
   */
  PREFERRED_INCREASE = 76,
  /**
   * 保险提额
   */
  INSURANCE_INCREASE = 1000,
  /**
   * 提额卡
   */
  NEW_RAISE_CREDIT_LIMIT_CARD = 81,
  /**
   * 联系人提额
   */
  CONTACTS = 83,
}

/**
 * 额度中心-提额失败/拒贷弹窗状态
 */
export enum AddAmountFailPopUpTypes {
  /**
   * 0 不弹；
   */
  NO_POPUP = 0,
  /**
   * 1 引导去提现，
   */
  TO_LOAN = 1,
  /**
   * 2 引导去提其他额度 LeadAddAmountTypes
   */
  TO_OTHER = 2,
  /**
   *  3 引导悦享借弹窗
   */
  TO_YXJ = 3,
}

/**
 * vip卡 排行榜类型
 */
export enum VipRankType {
  /**
   * 1-不定期提额
   */
  TEMP_INCREASE = 1,
  /**
   * 2-专属提额
   */
  INCREASE = 2,
  /**
   * 3-签到提额
   */
  SIGN_INCREASE = 3,
  /**
   *  4-不定期提额（真实）
   */
  TEMP_INCREASE_TRUTH = 4,
}

/**
 * vip 提额类型
 */
export enum VipAddAmountType {
  /**
   * 2-金币奖励
   */
  COIN_AWARD = 2,
  /**
   * 3-虚拟额度，额外提额奖励
   */
  EXTRO_INCREASE = 3,
  /**
   * 4-提额风控，签到提额奖励
   */
  SIGN_INCREASE = 4,
}

/**
 * vip 提额是否解锁
 */
export enum VipIncreaseStatus {
  /**
   * 1-未解锁
   */
  UNLOCK = 1,
  /**
   * 2-已解锁
   */
  LOCKED = 2,
  /**
   * 3-已使用
   */
  USED = 3,
}

/**
 * vip 用户是否已完成签到天数
 */
export enum VipSignStatus {
  /**
   * 1-已完成
   */
  FINISHED = 1,
  /**
   * 2-未完成
   */
  UNFINISHED = 2,
}

/**
 * vip 用户当天是否可以签到
 */
export enum VipIsSignedStatus {
  /**
   * 1-不可以签到
   */
  NOT_SIGN = 1,
  /**
   * 2-可以签到
   */
  SIGN = 2,
}

/**
 * vip 用户当天是否可以签到
 */
export enum ExclusiveAddAmountFailType {
  /**
   * 0-未领取
   */
  UNRECIVED = 0,
  /**
   * 1-已领取
   */
  RECIVED = 1,
}

/*
 *  开通协议支付类型
 */
export const enum SignType {
  /**
   *  H5方式开通协议支付
   */
  H5 = 1,
  /**
   * API方式开通协议支付
   */
  API = 2,
}

/**
 * 还款宝展示类型
 */
export enum HkbDisplayTypes {
  /**
   * 不展示
   */
  NONE = 0,
  /**
   * 嵌入页面
   */
  EMBED = 1,
  /**
   * 弹窗
   */
  POPUP = 2,
}

/**
 * 事件提醒覆写类型
 */
export enum RemindersRewriteTypes {
  /**
   * 默认始终为覆写
   */
  REWRITE = 0,
  /**
   * 仅存在时才覆写
   */
  REWRITE_IF_EXISTS = 1,
}

/**
 * 提额入口
 */
export enum AddAmountOrigin {
  /**
   * 提额中心
   */
  ADDAMOUNT_CENTER = 1,
  /**
   * 补充信息提额
   */
  INFORMATION = 2,
  /**
   * 借款页提额
   */
  LOAN = 3,
}

/**
 * 会员卡已购页提额结果状态
 */
export enum VipIncreaseResultStatus {
  /**
   * 提额中
   */
  WATING = 0,
  /**
   * 成功
   */
  SUCCESS = 1,
  /**
   * 失败
   */
  FAILED = 2,
  /**
   *未提额
   */
  UN_INCREASE = 4,
}

/**
 * 权益包类型
 */
export enum RightsInterestsTypes {
  /**
   * 分期权益包
   */
  INSTALLMENT = 1,
  /**
   * 分期+加速权益包
   */
  INSTALLMENT_ACCELERATOR = 2,
  /**
   * 加速包
   */
  ACCELERATOR = 3,
}

/**
 * 配置客服的页面
 */
export enum CustomerServiceSetPage {
  /**
   * 还款支付页
   */
  PAGE_REPAYMENT_CASHIER = 1,
  /**
   * 账单页
   */
  PAGE_REPAYMENT_BILL = 2,
}

/**
 * 补充资料提额状态
 */
export enum CreditLimitInformationStatus {
  /**
   * 初始化
   */
  INIT = 0,
  /**
   * 已提交
   */
  SUBMITTED = 1,
  /**
   * 已放弃
   */
  CANCELED = 2,
  /**
   * 过期自动取消
   */
  EXPIRED = 3,
  /**
   * 失败自动取消
   */
  FAILED = 4,
  /**
   * 已完成（放款成功）
   */
  FINISHED = 5,
  /**
   * 已点击提额但提额超时
   */
  SUBMITTED_TIMEOUT = 6,
  /**
   * 提额失败，提交原进件
   */
  ADD_AMOUNT_FAILED_APPLY = 7,
  /**
   * 失败自动取消，真实额度不足，无法进件
   */
  FAILED_AMOUNT_NOT_ENOUGH = 8,
  /**
   * 失败自动取消，异常情況
   */
  FAILED_EXCEPTION = 9,
  /**
   * 失败自动取消，不允许借款
   */
  FAILED_CANT_WITHDRAW = 10,
  /**
   * 失败自动取消，提额被拒
   */
  FAILED_ADD_MOUNT_DENY = 11,
  /**
   * 失败自动取消，提额失败
   */
  FAILED_ADD_MOUNT_FAILED = 12,
  /**
   * 提额中心提额
   */
  FAILED_ADD_AMOUNT_CENTER = 13,
  /**
   * 有额度，可提前用户
   */
  FAILED_ERROR = 14,
  /**
   * 提额超时，自动提交原进件
   */
  TIMEOUT_APPLY = 15,
  /**
   * 额度过期，自动提交原进件
   */
  EXPIRED_APPLY = 16,
  /**
   * 腾讯回调用户主动退出自动发起原进件
   */
  IS_TENCENT_QUIT = 17,
}

/**
 * 结清时挽留弹窗类型
 */
export enum SettleDetainmentTypes {
  /**
   * 不挽留
   */
  NO_DETAINMENT = 0,
  /**
   * 已有还款宝无奖励
   */
  DETAINMENT = 1,
  /**
   * 已有还款宝有奖励金红包
   */
  DETAINMENT_AWARD = 2,
  /**
   * 已有返现特权
   */
  DETAINMENT_FXTQ = 3,
  /**
   * 已有还款福利计划
   */
  DETAINMENT_HKFlJH = 4,
  /**
   * 已有还款福利金
   */
  DETAINMENT_HKFLJ = 5,
  /**
   * 首期提前结清-还款福利金
   */
  FT_HKFLJ = 6,
  /**
   * 首期提前结清-还款福利金-7天免息
   */
  FT_SEVEN_DAY_FREE = 7,
  /**
   * 剩余期次小于4期
   */
  LESS_FOUR = 8,
  /**
   * 剩余期次5~11期
   */
  BETWEEN_FIVE_ELEVEN = 9,
  /**
   * 预约成功
   */
  APPOINTMENT_CONFIRMED = 10,
  /**
   * 专属客服
   */
  DEDICATED_CUSTOMER_SERVICE = 11,
  /**
   * “预约结清已受理
   */
  TOAST = 12,
  /**
   * 展示联系客服弹窗
   */
  SHOW_CONTACTS_SERVICE_POPUP = 13,
}

export interface closeSettleDetainmentPopUpOptions {
  retainPopUpType: SettleDetainmentTypes;
}

/**
 * 退款时红包奖励金流量开关
 */
export enum HkbAwardStatus {
  /**
   * 不展示
   */
  NO_SHOW = 0,
  /**
   * 展示
   */
  SHOW = 1,
}

/**
 * 还款结果页的提额状态
 */
export enum AddAmountTypeStatus {
  /**
   * 不提额
   */
  NO_INCREASE = 0,
  /**
   * 临时提额
   */
  TEMPORARY = 1,
  /**
   * 固定提额
   */
  FIXATION = 2,
}

/**
 * 会员卡/解锁卡挽留弹窗类型
 */
export enum DetainmentPopupTypes {
  /**
   * 默认
   */
  DEFAULT = 0,
  /**
   * 待领取
   */
  UNRECEIVED = 1,
  /**
   * 待使用
   */
  UNUSED = 2,
  /*
   * 先用后付弹窗
   */
  LATER_PAY_POPUP = 3,
}

/**
 * 预约提额借款保存信息结果状态
 */
export enum ReserveLoanSaveInfoStatus {
  /**
   * 成功
   */
  SUCCESS = '0000',
  /**
   * 重复预约
   */
  REPEAT = '1111',
  /**
   * 名额已满
   */
  FULLED = '9999',
}

/**
 * 预约借款查询银行卡未签约次数页面类型
 */
export enum ReserveLoanSignCountPageType {
  /**
   * 预约借款页
   */
  LOAN = 1,
  /**
   * 查询结果页
   */
  RESULT = 2,
}

/**
 * 预约借款查询银行卡未签约次数页面类型
 */
export enum OriginPageTypes {
  /**
   * 提现页面
   */
  LOAN_PAGE = 2,
  /**
   * 提额页面
   */
  RAISE_LIMIT_PAGE = 3,
  /**
   * 还款页面
   */
  REPAYMENT_PAGE = 4,
}

/**
 * 联营洗自状态
 */
export enum AuditResultTypes {
  /**
   * 处理中
   */
  PENDING = 0,
  /**
   * 通过
   */
  PASS = 1,
  /**
   * 拒贷
   */
  REJECT = 2,
}

/**
 * 还款方式-还款记录页
 */
export enum RecordPaymentType {
  /**
   * 未知
   */
  UNKNOWN_PAY = 0,
  /**
   * 实时还款/协议支付
   */
  AGREEMENT_PAY = 1,
  /**
   * 预约还款
   */
  SUBSCRIBE_PAY = 2,
  /**
   * 快捷支付
   */
  QUICK_PAY = 3,
  /**
   * 展期旧合同结清
   */
  SETTLE_PAY = 4,
  /**
   * 支付宝还款
   */
  ALIY_PAY = 5,
}

/**
 * 注销挽留券包类型
 */
export enum CloseAccountCouponType {
  /**
   * 滴滴出行
   */
  DIDI = 29,
  /**
   * 故宫
   */
  GUGONG = 23,
  /**
   * 德宝
   */
  DEBAO = 24,
  /**
   * 蓝月亮
   */
  LANYUELIANG = 25,
  /**
   * 青岛啤酒
   */
  QINGDAOBEER = 26,
  /**
   * 元气森林
   */
  YUANQISENLIN = 27,
  /**
   * 周黑鸭
   */
  ZHOUHEIYA = 28,
  /**
   * 维达
   */
  WEIDA = 37,
}

/*
 * 银行卡绑卡场景值
 * 注意：它和银行卡类型,银行卡场景类型不是一个概念
 */
export const enum BindBankcardSceneCodes {
  /**
   * 预约借款
   */
  YYJK = 'YYJK',
  /**
   * 提现申请
   */
  TXSQ = 'TXSQ',
  /**
   * 资金源绑卡
   */
  ZJYBK = 'ZJYBK',
  /**
   * 静默放款
   */
  JMFK = 'JMFK',
  /**
   * 权益购买
   */
  QYGM = 'QYGM',
  /**
   * 主动还款
   */
  ZDHK = 'ZDHK',
  /**
   * 设置自动还款卡
   */
  SZHKK = 'SZHKK',
  /**
   * 零钱包
   */
  LQB = 'LQB',
  /**
   * 银行卡中心-添加银行卡
   */
  TJYHK = 'TJYHK',
  /**
   * 提现一键绑卡
   */
  TXYJBK = 'TXYJBK',
  /**
   * 贷前绑卡
   */
  DQSX = 'DQSX',
}

/**
 * 企业主一键提额状态
 */
export enum EnterpriseStatus {
  /**
   * 未出结果
   */
  WAITING = 1,
  /**
   * 提额成功需要上传营业执照
   */
  SUCCESS_UPLOAD = 2,
  /**
   * 提额失败需上传营业执照
   */
  FAILED_UPLOAD = 3,
  /**
   * 提额失败非企业主
   */
  NON_BUSINESS_OWNERS = 4,
  /**
   * 5-提额成功是企业主不需要上传营业执照
   */
  SUCCESS = 5,
  /**
   * 6-提额失败，是企业主但不需要上传营业执照
   */
  FAILED = 6,
}

/**
 * 小小微-税票/个人工商户提额授权结果状态
 */
export enum TaxAddAmountAuthStatus {
  /**
   * 初始化授权申请
   */
  INIT = 0,
  /**
   * 授权成功
   */
  AUTH_SUCCESS = 1,
  /**
   * 采集回调通知成功
   */
  CALLBACK_SUCCESS = 2,
  /**
   * 拉取文件成功
   */
  PULL_FILE_SUCCESS = 3,
  /**
   * 失败
   */
  FAIlED = 4,
}

/**
 * 解约卡重新绑卡入口来源
 */
export enum RebindCardEntryTypes {
  /**短信 */
  MSG = 1,
  /**
   * 还款账单弹窗
   */
  REPAY_POPUP = 2,
  /**
   * 首页弹窗
   */
  HOME_POPUP = 3,
  /**
   * 还款账单底部入口
   */
  REPAY_FOOTER_ENTRANCE = 4,
  /**
   * 银行卡中心
   */
  BANKCARD_CENTER = 5,
  /**
   * 还款结果页
   */
  REPAY_RESULT = 6,
  /**
   * 站内信
   */
  LETTER = 7,
}

/**
 * 解约卡重新绑卡入口来源文案映射
 */
export const RebindCardEntryTypesMap = {
  [RebindCardEntryTypes.MSG]: '短信',
  [RebindCardEntryTypes.REPAY_POPUP]: '账单页弹窗',
  [RebindCardEntryTypes.HOME_POPUP]: '首页弹窗',
  [RebindCardEntryTypes.REPAY_FOOTER_ENTRANCE]: '账单页',
  [RebindCardEntryTypes.BANKCARD_CENTER]: '银行卡管理页',
  [RebindCardEntryTypes.REPAY_RESULT]: '还款结果页弹窗',
  [RebindCardEntryTypes.LETTER]: '站内信',
};

/**
 * 悦享借-已购未购页面来源
 */
export enum SourcePageTypes {
  /**
   *未购页
   */
  NOT_BOUGHT_PAGE = 0,
  /**
   *已购页
   */
  BOUGHT_PAGE = 1,
}

/**
 * 积分任务-任务类型
 */
export enum TaskTypes {
  /**
   *首次授信
   */
  FIRST_CREDIT = '2',
  /**
   *首次提现
   */
  FIRST_LOAN = '3',
  /**
   *还款
   */
  REAPY = '4',
  /**
   *授信
   */
  CREDIT = '5',
  /**
   *提现
   */
  LOAN = '6',
  /**
   *提额
   */
  CREDIT_LIMIT = '7',
  /**
   *添加银行卡
   */
  ADD_BANK_CARD = '20',
  /**
   *关注微信公众号
   */
  FOCUS_WECHAT = '21',
}

export enum FaqTypes {
  LOAN = '1',
  REPAY = '2',
}

/**
 * 提额中心-页面样式类型
 */
export enum AddAmountPageTypes {
  /**
   * 带tab个人提额
   */
  XIAODAI_TAB_PAGE = 1,
  /**
   *不带tab个人提额
   */
  XIAODAI_NO_TAB_PAGE = 2,
  /**
   *企业主提额
   */
  ENTERPRISE_PAGE = 3,
  /**
   *无可用提额项
   */
  EMPTY_PAGE = 4,
}

export enum CarLoanStatus {
  NOT_ALLOW = 0,
  CAR_LOAN = 10,
  CAR_LOAN_RECORD = 20,
  CAR_LOAN_ABORT = 30,
}

export enum NewCarLoanStatus {
  /**
   *线索未采集
   */
  UN_COLLECT = 1010,
  /**
   *前筛被拒
   */
  REJECTED = 1020,
  /**
   *撞库被拒
   */
  STRIKE_REJECTED = 1030,
  /**
   *未发起预审
   */
  UN_APPLY = 1040,
  /**
   *审核中
   */
  APPLY_ING = 1050,
  /**
   *审核通过
   */
  APPLY_PASS = 1060,
  /**
   * 无身份证线索已提交
   */
  UN_IDCARD_APPLY = 1070,
  /**
   * 未实名认证无法预审
   */
  UN_REALNAME_APPLY = 1071,
  /**
   * 等待业务时间自动推送
   */
  WAIT_BUSINESS_TIME_PUSH = 1072,
}

export const carMap = [
  '京',
  '沪',
  '浙',
  '苏',
  '粤',
  '鲁',
  '晋',
  '冀',
  '豫',
  '川',
  '渝',
  '辽',
  '吉',
  '黑',
  '皖',
  '鄂',
  '津',
  '贵',
  '云',
  '桂',
  '琼',
  '青',
  '新',
  '藏',
  '蒙',
  '宁',
  '甘',
  '陕',
  '闽',
  '赣',
  '湘',
];

/**
 * 会员月卡跳转声昂行权类型
 */
export enum VipMonthCardChannelTypes {
  /**
   *视频影音5折
   */
  VIDEO = '10',
  /**
   *咖啡奶茶5折
   */
  COFFE = '11',
  /**
   * 电影美食5折
   */
  FOODS = '12',
  /**
   * 打车骑行5折
   */
  CARS = '13',
  /**
   * 专属好券
   */
  COUPONS = '15',
  /**
   *尊享月卡-视频影音5折
   */
  SVIP_VIDEO = '16',
  /**
   *尊享月卡-咖啡奶茶5折
   */
  SVIP_COFFE = '17',
  /**
   * 尊享月卡-电影美食5折
   */
  SVIP_FOODS = '18',
  /**
   * 尊享月卡-打车骑行5折
   */
  SVIP_CARS = '19',
  /**
   * 尊享月卡-专属好券
   */
  SVIP_COUPONS = '21',
  /**
   * 视频短剧
   */
  PLAYLET = '-1',
}

/**  测一测额度状态*/

export enum MeasureStatus {
  LESS_THAN_THOUSAND = 1,
  RANGE = 2,
  UNKNOWN = 3,
  REPEAT_MEASURE = 4,
}
/**
 * 会员月卡未购页区域名称
 */
export enum VipMonthCardHomeSections {
  FINANCE = 'finance',
  LIFE = 'life',
  SIGN = 'sign',
  COUPONS = 'coupons',
}
/**
 * 会员月卡tab区域名称
 */
export enum VipMonthCardTabNameList {
  FINANCE_TAB = 'financeTab', //金融特权
  LIFE_TAB = 'lifeTab', //生活特权
  SIGN_TAB = 'signTab', //签到特权
  COUPONS_TAB = 'couponsTab', //优享特权
}
/**
 * 会员月卡权益名称汇总
 */
export enum VipMonthCardRightsNameList {
  VIP_AMOUNT = 'vipAmount', //会员专属额度
  INCREASE_AMOUNT = 'increaseAmount', //专属提额机会
  LOAN = 'loan', //借款免息
  REPAY = 'repay', //还款返现
  APP_VIP = 'appVip', //热门视频会员
  VIDEO = 'video', //视频短剧
  COFFE = 'coffe', //咖啡奶茶
  FOODS = 'foods', //美食电影
  TRIP = 'trip', //出行
  COIN_SIGN = 'coinSign', //签到领金币
  CASH = 'cash', //现金兑换
  POINTS = 'points', //积分双倍
  DAY_COUPONS = 'dayCoupons', //每日福利
  PRIVATE_COUPONS = 'privateCoupons', //专属好券
  HEALTH = 'health', //健康特权
  MALLS = 'malls', //兑换商城
}
/**
 * 会员月卡tab区域名称对应文案
 */
export const VipMonthCardTabNameMap = {
  [VipMonthCardTabNameList.FINANCE_TAB]: '金融特权',
  [VipMonthCardTabNameList.LIFE_TAB]: '生活特权',
  [VipMonthCardTabNameList.SIGN_TAB]: '签到特权',
  [VipMonthCardTabNameList.COUPONS_TAB]: '优享特权',
};
/**
 * 提额中心-临时额度类型
 */
export enum AddAmountTmpAmountTypes {
  /**
   * 临时额度
   */
  TMP_AMOUNT = 1,
  /**
   *福利额度
   */
  MARKET_AMOUNT = 2,
  /**
   *会员额度
   */
  VIP_AMOUNT = 3,
}

/**
 * 还款福利金状态
 */
export enum RepayWelfareStatus {
  /**
   * 可领取（点亮）
   */
  CAN_DRAW = 1,
  /**
   * 已领取
   */
  DRAWED = 2,
  /**
   * 已失效
   */
  FAILURE = 3,
  /**
   * 作废
   */
  INVALID = 4,
  /**
   * 待领取（置灰）
   */
  WAIT_DRAW = 5,
}
/**
 * 广告主-业务来源类型
 */
export enum partnerSourceTypes {
  /**
   * 增验
   */
  CHECK = 'check',
  /**
   *正常
   */
  NORMAL = 'normal',
}

/**
 * 广告主-业务页面来源类型（乐享借api用）
 */
export enum partnerPageSourceTypes {
  /**
   * 绑卡页面
   */
  BIND_CARD_PAGE = 0,
  /**
   *非绑卡页面
   */
  NOT_BIND_CARD_PAGE = 1,
}

/**
 * 积分成就中心-成就奖励状态
 */
export enum awardStatus {
  /**
   * 未领取
   */
  UNRECEIVED = 1,
  /**
   *已领取
   */
  RECEIVED = 2,
  /**
   *未解锁
   */
  UNLOCK = 3,
}
/**
 * 还款账单页弹窗类型
 */
export enum RepayListPopTypes {
  /**
   * 1-资金源还款时间提醒弹窗/各资金源关闭时间提醒弹窗
   */
  REPAY_NO_ACCESS_POP = 1,
  /**
   *2-是否需要重新绑卡弹窗
   */
  REBIND_POP = 2,
  /**
   *3-企业主一键提额弹窗
   */
  BUSINESS_OWNER_POP = 3,
  /**
   *4-权益卡（会员月卡）弹窗
   */
  RIGHTS_CARD_POP = 4,
}

/**
 * 积分兑换-奖励类型
 */
export enum awardTypes {
  /**
   * 卡券
   */
  COUPON = 1,
  /**
   *实物
   */
  ENTITY = 2,
}

/**
 * 提额中心需要标记是否弹过的弹窗类型
 */
export enum CreditLimitCenterPopupTypes {
  /**
   * 1-推荐弹窗
   */
  RECOMMEND_POP = 1,
  /**
   *2-挽留弹窗
   */
  DETAINMENT_POP = 2,
  /**
   *3-调查问卷
   */
  QUESTION_POP = 3,
}

/**
 *  还款福利计划提现校验状态
 */
export enum HkflPlanCheckStatus {
  /**
   * 0-可直接提现
   */
  WITHDRAW = 0,
  /**
   *1-已领取金额>权益费用
   */
  WITHDRAW_DEDUCT_FAIl = 1,
  /**
   *2-已领取金额< =权益费用
   */
  WITHDRAW_DEDUCT_LOSE = 2,

  /**
   *3-未领取金额>权益费用
   */
  UNWITHDRAW_DEDUCT_FAIl = 3,

  /**
   *4-已领取金额>权益费用
   */
  UNWITHDRAW_DEDUCT_LOSE = 4,
}

/**
 * 还款福利计划每期金额可领取状态
 */
export enum HkflPlanAmountStatus {
  /**
   * 待领取
   */
  WAIT_DRAW = 0,
  /**
   * 可领取
   */
  CAN_DRAW = 1,
  /**
   *已领取
   */
  ALREADY_DRAW = 2,
  /**
   *已失效
   */
  LOSE_EFFICACY = 3,
}

/**
 * 还款福利计划总金额可领取状态
 */
export enum HkflPlanTotalAmountStatus {
  /**
   * 待提现
   */
  WAIT_TOP_UP = 1,
  /**
   *已提现
   */
  ALREADY_TOP_UP = 2,
  /**
   *已失效
   */
  LOSE_EFFICACY = 3,
  /**
   *不可提现
   */
  DISABLED_TOP_UP = 5,
}
/*
 * 强核身验证状态
 */
export enum EnforceVerifyStatus {
  /**
   * 等待验证
   */
  WAITING_VERIFY = 0,
  /**
   * 链接失效
   */
  LINK_INVALID = 1,
  /**
   * 验证成功
   */
  VERIFY_SUCCESS = 2,
  /**
   * 验证失败
   */
  VERIFY_FAIL = 3,
  /**
   * 核身材料提交成功
   */
  MATERIAL_SUBMITTED = 4,
}

/**
 * 签到页&钱包页会员月卡入口展示类型
 */
export enum VipMonthEntryTypes {
  /**
   * 不展示
   */
  NOT_SHOW = 0,
  /**
   * 未购入口
   */
  BUY_ENTRY = 1,
  /**
   * 已购入口
   */
  BOUGHT_ENTRY = 2,
}

/**
 * 挽留借款的弹窗类型
 */
export enum DetainmentLoanPopupTypes {
  /**
   * 临时额度
   */
  TEMP_CREDIT_LIMIT = 1,
  /**
   * 优惠券
   */
  COUPON = 2,
  /**
   * 去提额
   */
  GO_CREDIT_LIMIT = 3,
  /**
   * 风控提额或降息
   */
  RISK_CONTROL = 4,
  /**
   * 营销资源位
   */
  MARKETING_RESOURCE = 5,
  /**
   * 已提额
   */
  RAISED_CREDIT_LIMIT = 6,
  /**
   * 已降息
   */
  REDUCED_INTEREST_RATES = 7,
}

/**
 * 退款类型
 */
export enum RefundType {
  /**
   * 允许全额退款
   */
  FULL_REFUND = 0,
  /**
   * 允许部分退款
   */
  PART_REFUND = 1,
}
/**
 * 弹窗中心-页面类型
 */
export enum PopupCenterPageMarkTypes {
  /**
   * 还款列表页面
   */
  REPAY_LIST_PAGE = 'REPAY_LIST_PAGE',
  /**
   * 借款记录页面
   */
  LOAN_RECORD_PAGE = 'LOAN_RECORD_PAGE',
  /**
   * 还款记录页面
   */
  REPAY_RECORD_PAGE = 'REPAY_RECORD_PAGE',
  /**
   * 用户签到页面
   */
  USER_SIGN_PAGE = 'USER_SIGN_PAGE',
  /**
   * 用户钱包页面
   */
  USER_WALLET_PAGE = 'USER_WALLET_PAGE',
  /**
   * 账单详情页面
   */
  REPAYMENT_SCHEDULE_PAGE = 'REPAYMENT_SCHEDULE_PAGE',
  /**
   * 银行卡中心页面
   */
  BANK_LIST_PAGE = 'BANK_LIST_PAGE',
  /**
   * 结清证明页面
   */
  COMPLETED_PROVE_PAGE = 'COMPLETED_PROVE_PAGE',
  /**
   * 查看合同页面
   */
  CONTRACT_PAGE = 'CONTRACT_PAGE',
  /**
   * 还款支付结果页面
   */
  PAY_RESULT_PAGE = 'PAY_RESULT_PAGE',
  /**
   * 悦享借页面
   */
  YXJ_PAGE = 'YXJ_PAGE',
  /**
   * 二次风控拒贷后 - 天下信用引导页面
   */
  SECOND_AUDIT_DENY_PAGE = 'SECOND_AUDIT_DENY_PAGE',
  /**
   * 资金匹配页
   */
  EVAL_PAGE = 'EVAL_PAGE',
  /**
   * 跃升卡详情页
   */
  IMPROVE_CARD_DETAIL_PAGE = 'IMPROVE_CARD_DETAIL_PAGE',
  /**
   * 提额中心页
   */
  CREDIT_LIMIT_CENTER_PAGE = 'CREDIT_LIMIT_CENTER_PAGE',
  /**
   * 提额子页面返回
   */
  CREDIT_UP_SUB_PAGE_BACK = 'CREDIT_UP_SUB_PAGE_BACK',
}

/**
 * 弹窗中心-弹窗类型
 */
export enum PopupCenterPopupTypes {
  /**
   * 会员月卡弹窗
   */
  VIP_POP = 'VIP_POP',
  /**
   * 会员月卡浮动气泡
   */
  VIP_FLOAT_BUBBLE = 'VIP_FLOAT_BUBBLE',
  /**
   * 会员月卡挽留弹窗
   */
  RETAIN_VIP_POP = 'RETAIN_VIP_POP',
  /**
   * 天创信用浮动气泡
   */
  TCXY_FLOAT_BUBBLE = 'TCXY_FLOAT_BUBBLE',
  /**
   * 天创信用挽留弹窗
   */
  TCXY_RETAIN_POPUP = 'TCXY_RETAIN_POPUP',
  /**
   * 天创信用弹窗（验证身份后四位）
   */
  TCXY_COMPONENT_POPUP = 'TCXY_COMPONENT_POPUP',
  /**
   *资金源还款时间提醒弹窗
   */
  REPAY_NO_ACCESS_TEMP_POPUP = 'REPAY_NO_ACCESS_TEMP_POPUP',
  /**
   *  是否需要重新绑卡弹窗
   */
  SHOW_REBIND_CARD_POPUP = 'SHOW_REBIND_CARD_POPUP',
  /**
   *  是否需要重新绑卡弹窗
   */
  BUSINESS_OWNER_POPUP = 'BUSINESS_OWNER_POPUP',
  /**
   * 保险-非自动跳转到商城弹窗
   */
  INSURANCE_MALL = 'INSURANCE_MALL',
  /**
   * 保险弹窗
   */
  YXJ_INSURANCE = 'YXJ_INSURANCE',
  /**
   * 跃升卡详情页-挽留弹窗
   */
  IMPROVE_CARD_RETAIN_POPUP = 'IMPROVE_CARD_RETAIN_POPUP',
  /**
   * 跃升卡详情页-挽留弹窗-先享后付
   */
  IMPROVE_CARD_BNPL_RETAIN_POPUP = 'IMPROVE_CARD_BNPL_RETAIN_POPUP',
  /**
   * 资金匹配页-退出-跃升卡挽留弹窗
   */
  IMPROVE_CARD_EVAL_RETAIN_POPUP = 'IMPROVE_CARD_EVAL_RETAIN_POPUP',
  /**
   * 资金匹配页-退出-保险挽留弹窗
   */
  INSURANCE_EVAL_RETAIN_POPUP = 'INSURANCE_EVAL_RETAIN_POPUP',
  /**
   * 资源位
   */
  RESOURCE = 'RESOURCE',
}

/**
 * 弹窗中心-弹窗大类型
 */
export enum PopCenterPopClass {
  /**
   * 弹窗
   */
  POP = 1,
  /**
   * 气泡
   */
  BUBBLE = 2,
  /**
   * 页面元素
   */
  PAGE_ELEMENT = 3,
}
/**
 * 大转盘奖品类型
 */
export const enum PrizeTypes {
  /**
   * 宜享花券
   */
  TICKET = 1,
  /**
   * 实物
   */
  ENTITY = 2,
  /**
   * 宜享花积分
   */
  INTEGRAL = 3,
  /**
   * 福利额度
   */
  WELFARE_LIMIT = 4,
}

/**
 * 广告主提额中心提额结果
 */
export const enum AccessResultTypes {
  /**
   * 不是广告主
   */
  NOT_DIVERSION = 0,
  /**
   * 等待准入
   */
  ACCESS_WAITING = 10,
  /**
   * 准入成功
   */
  ACCESS_SUCCESS = 20,
}
/**
 * 登录来源
 */
export const enum LoginSourceTypes {
  /**
   * 活动
   */
  ACTIVITY = 1,
  /**
   * 抽奖
   */
  LOTTERY = 2,
}

export const enum ActivityCustomizationTypes {
  /**
   * 超额召回
   */
  RECALL = 'recall',
}

/**
 * 大转盘页面类型
 */
export const enum LotteryPageTypes {
  /**
   * -1活动结束页
   */
  END = -1,
  /**
   * 正常抽奖页
   */
  DEFAULT = 0,
  /**
   * 客群不符
   */
  MIS_MATCHED = 1,
}

/**
 * 大转盘页面文案颜色类型
 */
export const enum LotteryPageFontColorTypes {
  /**
   * 头部规则文案
   */
  RULE = 1,
  /**
   * 抽奖次数文案
   */
  TIPS = 2,
  /**
   * 奖品弹窗文案
   */
  POPUP = 3,
  /**
   * 奖品弹窗按钮文案
   */
  POPUP_BUTTON = 4,
}

/**
 * 消保-客服服务进度-工单处理状态
 */
export const enum IssueOrderStatus {
  /**
   * 处理中
   */
  PENDING = 1,
  /**
   * 已处理
   */
  FINISHED = 2,
}
export const IssueOrderStatusMap = {
  [IssueOrderStatus.PENDING]: '正在处理中',
  [IssueOrderStatus.FINISHED]: '已处理完成',
};
/**
 * 消保-客服服务进度-工单来源类型
 */
export const enum IssueOrderSourceType {
  /**
   * 诈骗举报
   */
  PENDING = 1,
  /**
   * 投诉
   */
  FINISHED = 2,
  /**
   * 对公还款协助入账
   */
  PUBLIC_REPAY = 3,
}
export const IssueOrderSourceTypeMap = {
  [IssueOrderSourceType.PENDING]: '诈骗举报',
  [IssueOrderSourceType.FINISHED]: '投诉',
  [IssueOrderSourceType.PUBLIC_REPAY]: '对公还款协助入账',
};
/**
 * 消保-客服服务进度-工单消息发送人
 */
export const enum IssueOrderReplyRole {
  /**
   * 宜享花
   */
  YXH = 1,
  /**
   * 客户
   */
  CUSTOMER = 2,
}
/**
 * 消保-客服服务进度-工单补充信息类型
 */
export const enum IssueOrderOptType {
  /**
   * 其他
   */
  OTHER = 0,
  /**
   * 补充联系方式
   */
  CONTACT = 1,
  /**
   * 补充内容
   */
  CONTENT = 2,
}

/**
 * 页面分流配置信息
 */
export const enum PageDiversionType {
  /**
   * 借款排队页
   */
  LOAN_QUEUE = 'lending',
  /**
   * 合同页面
   */
  CONTRACT = 'contract',
  /**
   * 提现页
   */
  LOAN = 'applyLoanPage',
}

/**
 * 用户页面分流保险商城页面标识
 */
export const enum PageDiversionActionType {
  /**
   * 新版提现页
   */

  NEW_LOAN = 'newLoanPageSwitch',
  /**
   * 提现页利率展示样式
   */
  LOAN_RATE_STYLE = 'interestStyle',
}

/**
 * 提现页、广告主提现页新版权益礼包类型
 */
export const enum LoanRightsTypes {
  /**
   * 宜享优选通道
   */
  PREFERED = 1,
  /**
   * 常规通道
   */
  NORMAL = 2,
}

/**
 * 增验(requireCheck)类型
 * 用于广告主提现流程中的增验步骤判断
 */
export const enum RequireCheckTypes {
  /**
   * 不需要增验
   */
  NONE = '0',
  /**
   * 短信验证
   */
  SMS = '1',
  /**
   * 人脸验证
   */
  FACE = '2',
  /**
   * OCR身份证识别
   */
  OCR = '3',
  /**
   * 资料补充 + 协议签署
   */
  INFO_AND_AGREEMENT = '4',
  /**
   * 仅资料补充
   */
  INFO_ONLY = '5',
  /**
   * 仅协议签署
   */
  AGREEMENT_ONLY = '6',
}

/**
 * 问卷场景
 */
export const enum QuestionnaireScene {
  /**
   * 自定义
   * @type {Number}
   */
  CUSTOM = 0,
  /**
   * 注销
   * @type {Number}
   */
  CANCEL = 1,
  /**
   * OCR
   * @type {Number}
   */
  OCR = 2,
  /**
   * 人脸
   * @type {Number}
   */
  FACE = 3,
  /**
   * 结清
   * @type {Number}
   */
  SETTLE = 4,

  /**
   * 权益退订
   */
  ORDER_CANCEL_RENEW = 7,
  /**
   * 权益退费
   */
  ORDER_REFUND = 8,
  /**
   * 权益取消订单
   */
  ORDER_CANCEL_SUPPLEMENT = 9,

  /**
   * 会员月卡退费（新版挽留）
   */
  VIP_REFUND = 10,
}

/**
 * 问卷问题类型
 */
export const enum QuestionType {
  /**
   * 单选
   * @type {Number}
   */
  RADIO = 1,
  /**
   * 复选
   * @type {Number}
   */
  CHECKED = 2,
  /**
   * 文本
   * @type {Number}
   */
  TEXT = 3,
}

/**
 * 问卷挽留策略状态
 */
export const enum StrategyStatus {
  /**
   * 不需要
   * @type {Number}
   */
  NO_NEED = -1,
  /**
   * 调用中
   * @type {Number}
   */
  CALL_ING = 1,
  /**
   * 成功
   * @type {Number}
   */
  CALL_SUCCESS = 2,
  /**
   * 失败
   * @type {Number}
   */
  CALL_FAILED = 3,
}

/**
 * 问卷挽留类型
 */
export const enum DetainmentStrategyMap {
  /**
   * 默认
   */
  default = 'default',
  /**
   * 风控提额
   */
  riskAddAmount = 'riskAddAmount',
  /**
   * 营销提额
   */
  marketingAddAmount = 'marketingAddAmount',
  /**
   * 风控降价
   */
  riskDiscount = 'riskDiscount',
  /**
   * 营销降价
   */
  marketingDiscount = 'marketingDiscount',
  /**
   * 解冻
   */
  unfreeze = 'unfreeze',
  /**
   * 广告主
   */
  diversion = 'diversion',
  /**
   * 专属客服
   */
  contactCustomerService = 'contactCustomerService',
  /**
   * 降息
   */
  couponReduceInterest = 'couponReduceInterest',
  /**
   * 重审
   */
  reAudit = 'reAudit',
}

/**
 * 广告主提现页权益礼包模式类型
 */
export const enum PartnerRightModelTypes {
  /**
   * tab切换形式
   */
  TAB = 1,
  /**
   * 勾选形式
   */
  CHECK = 2,
  /**
   * 单通道勾选模式
   */
  SINGLE_CHANNEL_CHECK = 3,
}

/**
 * 广告主soure类型
 */
export const enum PartnerSourceTypes {
  /**
   * 补充资料-机构提额-引导页
   */
  PAGE_SUPPLEMENT_GUIDE = 'page_supplement_guide',
  /**
   * 提现申请页
   */
  PAGE_LOAN_APPLY = 'page_loan_apply_normal',
  /**
   * 资料补充页
   */
  PAGE_SUPPLEMENT_NORMAL = 'page_supplement_normal',
  /**
   * 授信中页
   */
  PAGE_CREDITING_PAGE = 'page_crediting_page',
  /**
   * 提现确认-机构提额-引导页
   */
  PAGE_LOAN_CONFIRM_GUIDE = 'page_loan_confirm_guide',
  /**
   * 提现确认页
   */
  PAGE_LOAN_CONFIRM = 'page_loan_confirm_normal',
  /**
   * 借款结果页
   */
  PAGE_LOAN_RESULT = 'page_loan_result_normal',
  /**
   * 插队排队页
   */
  PAGE_LOAN_APPLY_WAITING_NORMAL = 'page_loan_apply_waiting_normal',
  /**
   * 提额中心中转页-至排队页
   */
  PAGE_LOAN_CONFIRM_WAITING_INCREASE_AMOUNT = 'page_loan_confirm_waiting_increase_amount',
}

/**
 *  订单列表类型
 */
export const enum OrderTypes {
  /**
   * 各种权益卡订单
   */
  GOODS = 1,
  /**
   * 权益包订单
   */
  RIGHTS = 2,
}

/**
 *  订单列表类型
 */
export const enum RightModels {
  /**
   * 趸缴
   */
  DUNJIAO = 0,
  /**
   * 期缴，缩期
   */
  QIJIAO = 1,
}

/**
 *  挽留或非挽留退款类型
 */
export const enum RetainRefundTypes {
  /**
   * 非挽留
   */
  NORMAL = 0,
  /**
   * 挽留流程后
   */
  RETAIN = 1,
}

/**
 * 提现页权益包升级新类型
 */
/**
 *  订单列表类型
 */
export const enum LoanNewRightsTypes {
  /**
   * 生活
   */
  LIFE = 56,
  /**
   * 短剧
   */
  PLAYLET = 57,
  /**
   * 保险权益
   */
  INSURANCE = 58,
}

/**
 * 自营分流/开关配置类型
 */
export const enum YxhLoanDiversionTypes {
  /**
   *九号文二期-提现页权益包利益点调整
   */
  // NEW_RIGHTS_TEXT_HAS_FINACE = 'yxh:diversion:loanRightsNewTextHasFinace',
  /**
   * 九号文二期-提现页年化利率是否联动
   */
  // NEW_RIGHTS_RATE = 'yxh:diversion:loanRightsRateSyncVersion',
  /**
   * 九号文二期-提现页权益包是否包含金融利益点与年化利率是否联动
   */
  NEW_RIGHTS_RATE_AND_HAS_FINACE = 'yxh:diversion:loan:rateSyncAndHasFinace',
  /**
   * 九号文二期-提现页优享通道勾选权益包协议是否展示
   */
  NEW_RIGHTS_AGREEMENT = 'yxh:diversion:loanRightsShowAgreement',
  /**
   * 九号文二期-提现页未勾选优享通道挽留弹窗文案
   */
  NEW_RIGHTS_DETAINMENT_POP_TEXT = 'yxh:diversion:loanRightsDetainmentPopText',
  /**
   * 提现页非24利率强制AMC
   */
  NOT24_MANDATORY_AMC = 'yxh:diversion:loan:not24:mandatoryAMC',
  /**
   * 我的额度页不展示倒计时
   */
  NO_COUNT_DOWN = 'yxh:config:myAmount:noCountDown:IPAndPhone:provinces',
  /**
   * 提现页仅调一次预路由
   */
  ONLY_ONE_PRE_ROUTE = 'yxh:diversion:loan:onlyOnePreRoute',
  /**
   * 进入查看合同页面是否需要人脸开关
   */
  ENTER_CONTRACT_FACE_SWITCH = 'yxh:switch:contract:faceSwitch',
  /**
   * 进入结清证明页面是否需要人脸开关
   */
  ENTER_SETTLEMENT_PROOF_FACE_SWITCH = 'yxh:switch:settlementProof:faceSwitch',
  /**
   * 进入借款记录页面是否需要人脸开关
   */
  ENTER_LOAN_RECORD_FACE_SWITCH = 'yxh:switch:loanRecord:faceSwitch',
  /**
   * 悦享借已购页是否展示额度、享借服务、专属福利
   */
  YXJ_930_SWITCH = 'yxh:diversion:yxj930',
  /**
   * 搭售臻选计划权益信息
   */
  SALE_RIGHT_VIP_MONTH_INFO = 'yxh:config:loan:vipMonthCardInfo',
  /**
   * 搭售信用报告权益信息
   */
  SALE_RIGHT_CREDIT_REPORT_INFO = 'yxh:config:loan:creditReportInfo',
  /**
   * 添加银行卡页面样式 默认off 优先显示输入卡号样式
   */
  BANKCARD_PAGE_QUICK_BIND_FIRST = 'yxh:diversion:bankcard:quickBindFirst',
  /**
   * 提现页权益分期中优选通道文案下方金额
   */
  NEW_RIGHTS_MONTH_REPAY_AMOUNT = 'yxh:diversion:loan:newRightsInterestsCard:monthRepayAmount',
  /**
   * 提现页还款计划增加还款日等文案
   */
  LOAN_SHOW_MERGE_REPAY_PLAN_TEXT = 'yxh:diversion:loan:showMergeRepayPlanText',
  /**
   * 提现页搭售会员月卡tab卡片上展示勾选协议
   */
  LOAN_SALE_RIGHT_TAB_CHECK_AGREEMENT = 'yxh:diversion:loan:vipMonthCard:tabShowCheckAgreement',
  /**
   * 添加银行卡页面展示一键绑多卡入口
   */
  BANKCARD_PAGE_BIND_MULTI_CARD = 'yxh:diversion:h5:addCard:bindMultiCard',
  /**
   * 投放落地页012下载页样式分流
   */
  TF_12_DOWNLOAD_PAGE_STYLE = 'yxh:multi_diversion:channel:12downloadAppPageStyle',
  /**
   * 投放落地12下载页android手机使用应用商店下载分流控制，大于流量值直接下载apk，小于流量值跳转应用商店下载
   */
  TF_12_DOWNLOAD_MODE = 'yxh:config:channel:12downloadAppMode',
  /**
   * 投放落地页007下载页样式分流
   */
  TF_07_DOWNLOAD_PAGE_STYLE = 'yxh:multi_diversion:channel:07downloadAppPageStyle',
  /**
   * 投放落地007下载页android手机使用应用商店下载分流控制，大于流量值直接下载apk，小于流量值跳转应用商店下载
   */
  TF_07_DOWNLOAD_MODE = 'yxh:config:channel:07downloadAppMode',
  /**
   * 投放落地页011下载页样式分流
   */
  TF_11_DOWNLOAD_PAGE_STYLE = 'yxh:multi_diversion:channel:11downloadAppPageStyle',
  /**
   * 投放落地011下载页android手机使用应用商店下载分流控制，大于流量值直接下载apk，小于流量值跳转应用商店下载
   */
  TF_11_DOWNLOAD_MODE = 'yxh:config:channel:11downloadAppMode',
  /**
   * 会员月卡9入口价格
   */
  VIP_MONTH_CARD_9_ENTRY_PRICE = 'yxh:config:vipMonthCard9EntryPrice',
  /**
   * 资金匹配页跃升卡展示页面
   */
  LOAN_SHOW_UPGRADE_CARD_PAGE = 'yxh:diversion:loan:showUpgradeCardPage',
  /**
   * 关闭账号（兜底流程）-点击坚持注销-客服弹窗 隐藏“坚持注销入口”
   */
  CLOSE_ACCOUNT_HIDE_CANCEL_CUSTOMER_SERVICE = 'yxh:diversion:closeAccount:hideCancel',
  /**
   * 完善信息页GPS和联系人权限功能分流
   */
  INFORMATION_COMPLETE_GPS_AND_CONTACT = 'yxh:diversion:information:complete:GpsAndContact',
  /**
   * 注销挽留新老流程分流
   */
  CLOSE_ACCOUNT_DETAINMENT = 'yxh:diversion:closeAccount:detainment',
  /**
   * 拒贷页新老版本分流
   */
  REJECTED_PAGE_NEW_VERSION = 'yxh:diversion:credit:rejected:new',
  /**
   * 提现页后置OCR验证开关
   */
  LOAN_NEED_AFTER_OCR = 'yxh:diversion:loan:needAfterOcr',
  /**
   * 提现页后置个人信息验证开关
   */
  LOAN_NEED_AFTER_PERSONAL_INFO = 'yxh:diversion:loan:needAfterPersonalInfo',
  /**
   * 提现页后置联系人验证开关
   */
  LOAN_NEED_AFTER_CONTACT_INFO = 'yxh:diversion:loan:needAfterContactInfo',
  /**
   * 提现页权益包样式
   */
  LOAN_RIGHT_INTEREST_PACK_STYLE = 'yxh:diversion:loan:rightInterestPackStyle',
  /**
   * 提现评估超时页文案分流
   */
  LOAN_TIMEOUT_TEXT = 'yxh:diversion:loan:timeout:text',
  /**
   * H5收银台续费样式与协议勾选分流
   */
  PAYBAR_RENEW_STYLE = 'yxh:diversion:h5:payBar:autoRenwStyle:ratio',
  /**
   * 提现页-搭售会员月卡、信用报告配置新老版本分流
   */
  LOAN_BUNDLE_SETTING_STYLE = 'yxh:diversion:loan:bundle:strategy:engine:switch:ratio',
  /**
   * 资金匹配页-搭售会员月卡、信用报告配置新老版本分流
   */
  WAITING_FUND_BUNDLE_SETTING_STYLE = 'yxh:diversion:fund:match:bundle:strategy:engine:switch:ratio',
  /**
   * 还款页-搭售会员月卡、信用报告配置新老版本分流
   */
  REPAY_BUNDLE_SETTING_STYLE = 'yxh:diversion:repay:bundle:strategy:engine:switch:ratio',
  /**
   * 提额页-搭售会员月卡、信用报告配置新老版本分流
   */
  AMOUNT_BUNDLE_SETTING_STYLE = 'yxh:diversion:add:amount:bundle:strategy:engine:switch:ratio',
  /**
   * 提现页-提现页展示搭售信用报告卡片挽留弹窗与挽留弹窗勾选协议配置开关
   */
  LOAN_SHOW_CREDIT_REPORT_CONFIG = 'yxh:diversion:loan:showSaleCreditReportConfig:ratio',
  /**
   * 提现页-提现页展示搭售会员月卡卡片挽留弹窗与挽留弹窗勾选协议配置开关
   */
  LOAN_SHOW_VIP_MONTH_CARD_CONFIG = 'yxh:diversion:loan:showSaleVipMonthCardConfig:ratio',
  /**
   * 提现页强展协议弹窗优先展示借款协议Tab展示比例
   */
  LOAN_AGREEMENT_POP_FIRST_SHOW_LOAN_TAB = 'yxh:diversion:h5:loanAgreement:firstShowLoanAgreementTab:ratio',
  /**
   * 补签签约页 PRE 红包弹窗是否自动跳转
   */
  SUP_CARD_SIGN_PRE_AUTO_JUMP = 'yxh:diversion:h5:supCardSign:Pre:AutoJump',
  /**
   * 导流授信审核中页强制等待时长（秒）
   */
  CREDIT_AUDIT_BUNDLE_WAIT_TIME = 'yxh:diversion:credit:audit:bundle:wait:time:ratio',
}

/**
 *  资金匹配页36确认权益包弹窗类型
 */
export const enum LoanForce36ConfirmRightsTypes {
  /**
   * 纯36
   */
  PURE_36 = '36',
  /**
   * 非纯36
   */
  NOT_PURE_36 = 'SRD36',
  /**
   * 包含2种弹窗
   */
  BOTH = 'BOTH',
}

/**
 *  权益模式挽留模式
 */
export const enum RightsRetentionModeTypes {
  /**
   * 简易版（只有权益挽留）
   */
  SIMPLE = 1,
  /**
   * 通用版
   */
  GENERAL = 2,
}

/**
 * 提额卡提额结果状态
 */
export const enum RaiseCreditLimitCardResultStatus {
  /**
   * 提额中
   */
  LOADING = 1,
  /**
   * 提额成功
   */
  SUCCESS = 2,
  /**
   * 提额失败
   */
  FAILED = 3,
}

/**
 * 搭售权益具体类型
 */
export const enum SaleRightsTypes {
  /**
   * 会员月卡（臻选计划）
   */
  VIP_MONTH_CARD = 'vipMonthCard',
  /**
   * 会员月卡（臻选计划）
   */
  VIP_ZX_MONTH_CARD = 'vipZxMonthCard',
  /**
   * 会员月卡（通用卡片）
   */
  VIP_MONTH_CARD_COMMON = 'vipMonthCommon',
  /**
   * 优鉴信用报告
   */
  YJ_CREDIT_REPORT = 'yjCreditReport',
  /**
   * 天创信用报告
   */
  TC_CREDIT_REPORT = 'tcCreditReport',
  /**
   * 还款宝
   */
  HKB_REPAY_TREASURE = 'hkbRepayTreasure',
  /**
   * 砺带还款宝
   */
  LIDA_REPAYMENT_CARD = 'ldhkbRepayTreasure',
}

/**
 * 搭售权益包大类类型
 */
export const BundleSaleRightsTypes = {
  /**
   * 信用报告
   */
  CREDIT_REPORT: 'CREDIT_REPORT',
  /**
   * 会员月卡
   */
  MONTH_CARD: 'MONTH_CARD',
  /**
   * 还款宝
   */
  REPAY_TREASURE: 'REPAY_TREASURE',
  /**
   * 砺带还款宝
   */
  REPAY_LD_TREASURE: 'REPAY_LD_TREASURE',
  /**
   * 保险
   */
  INSURANCE: 'INSURANCE',
};

/**
 * 搭售权益页面名称
 */
export const enum SaleRightsPageNames {
  /**
   * 提现页
   */
  LOAN = 'loan',

  /**
   * 还款页
   */
  APP_REPAY = 'appRepay',

  /**
   * 提现页
   */
  DIVERSE_LOAN = 'diversionLoan',
  /**
   * 资金匹配页
   */
  FUND_MATCH = 'fundMatch',
  /**
   * 导流授信等待页
   */
  DIVERSE_CREDIT_WAIT = 'diversionCreditWait',
  /**
   * 导流授信页
   */
  DIVERSE_OFFLINE_TAG_CREDIT = 'diversionOfflineTagCredit',
  /**
   * 导流提现确认页
   */
  DIVERSE_LOAN_CONFIRM = 'diversionLoanConfirm',
  /**
   * 导流提现结果页
   */
  DIVERSE_LOAN_RESULT = 'diversionLoanResult',
  /**
   * 还款结果页
   */
  APP_REPAY_RESULT = 'appRepayResult',
}

/**
 * 权益主体
 */
export const enum PayEntityTypes {
  /**
   * 砺带
   */
  LD = 'LD03',
  /**
   * 杉海
   */
  SH = 'SH',
}

/*
 * 臻选弹窗页面类型
 */
export const enum CuratedRaiseDetainmentPopupPageNames {
  /**
   * 三个提额项页面强展位置
   */
  APP_ADD_AMOUNT = 'APP_ADD_AMOUNT',
  /**
   * 三个提额项页面返回按钮位置
   */
  APP_ADD_AMOUNT_BACK_BUTTON = 'APP_ADD_AMOUNT_BACK_BUTTON',
  /**
   * 三个提额项结果页面中间预留位置
   */
  APP_ADD_AMOUNT_RESULT_PAGE = 'APP_ADD_AMOUNT_RESULT_PAGE',
  /**
   * 三个提额项结果页面返回按钮位置
   */
  APP_ADD_AMOUNT_RESULT_PAGE_BACK_BUTTON = 'APP_ADD_AMOUNT_RESULT_PAGE_BACK_BUTTON',
}

/**
 * 用户类型-首贷/复贷
 */
export const enum UserTypes {
  /**
   * 首贷
   */
  FIRST_LOAN = 1,
  /**
   * 复贷
   */
  REPEAT_LOAN = 2,
}

/**
 * 人脸识别提供方
 */
export const enum FaceProviderTypes {
  /**
   * 第三方
   */
  THIRD_PARTY = 'thirdParty',
  /**
   * 自研
   */
  SELF_RESEARCH = 'selfResearch',
}

/**
 * 权益相关分流配置
 */
export const enum GoodsDiversionTypes {
  // app 跃升卡详情页 ab 实验流配置
  UPGRADE_CARD_ABTEST = 'yxh:diversion:goods:upgradeCardABTest',
}

/**
 * 投放落地页页面类型
 */
export const enum LPPageType {
  /**
   * 登录页
   */
  Login = 'login',
  /**
   * 下载页
   */
  Download = 'download',
}

/*
 * 元素跳转类型-资源位
 */
export const enum ComponentRedirectTypes {
  /**
   * 跳转报告弹窗验证
   */
  REDIRECT_CREDIT_REPORT_COMPONENT = 4,
  /**
   * 跳转会员弹窗验证
   */
  REDIRECT_VIP_MONTH_COMPONENT = 5,
}

/**
 * 24定价差异化展示标识
 *
 */
export const enum Pricing24DifferentialDisplayIdentifier {
  /**
   * 是
   */
  YES = 1,
  /**
   * 否
   */
  NO = 0,
}

/**
 * 行权弹窗权益状态
 */
export const enum ExercisePopupRightsStatus {
  /**
   * 待领取
   */
  WAIT_RECEIVE = 0,
  /**
   * 发放中
   */
  RECEIVING = 1,
  /**
   * 去使用
   */
  TO_USE = 2,
  /**
   * 失败
   */
  FAIL = 3,
}

/**
 * 行权弹窗权益类型
 */
export const enum BenefitTypes {
  /**
   * 会员福利提额
   */
  BONUS_VIP_AMOUNT = 'BONUS_VIP_AMOUNT',
  /**
   * 借款折扣券
   */
  INTEREST_DISCOUNT = 'INTEREST_DISCOUNT',
  /**
   * 还款随机返现券
   */
  REPAYMENT_RANDOM_CASH_BACK = 'REPAYMENT_RANDOM_CASH_BACK',
  /**
   * 美团外卖券
   */
  MT_COUPON_PACK = 'MEITUAN_COUPON_PACK',
}

/**
 * 行权弹窗权益发放方式
 */
export const enum receiveMethodTypes {
  /**
   * 自动发放
   */
  AUTO = 'AUTO',
  /**
   * 手动发放
   */
  MANUAL = 'MANUAL',
}

/**
 *  资源位业务类型
 */
export enum ResourceBusinessType {
  /**
   * 运营
   */
  OPERATION = 1,
  /**
   * 中收
   */
  MIDDLE_RECEIPT = 2,
  /**
   * 保险
   */
  INSURANCE = 3,
  /**
   * 导流
   */
  PARTNER = 4,
}
/**
 *  H5新C面还款账单区域类型
 */
export enum H5CRepaymentType {
  /**
   * 已还清
   */
  COMPLETED = 1,
  /**
   * 今日待还
   */
  CURRENT_DAY_HAS_REPAY = 2,
  /**
   * 剩余几天，有待还
   */
  DAYS_HAS_REPAY = 3,
  /**
   * 近期待还
   */
  MORE_DAYS_HAS_REPAY = 4,
  /**
   * 无还款信息
   */
  NONE_REPAY = 5,
}

/**
 * 应用商店评价状态
 */
export enum CommentSatisfaction {
  /**
   * 未评价
   */
  UNEVALUATED = 0,
  /**
   * 满意
   */
  SATISFIED = 1,
  /**
   * 一般
   */
  AVERAGE = 2,
  /**
   * 不满意
   */
  UNSATISFIED = 3,
}

/**
 * 应用商店评价入口
 */
export enum CommentEntryType {
  /**
   * 个人中心
   */
  PERSONAL_CENTER = 1,
  /**
   * 还款成功
   */
  REPAYMENT_SUCCESS = 2,
}

/**
 * 评价审核状态
 */
export enum CommentAuditStatus {
  /**
   * 初始化
   */
  INIT = 0,
  /**
   * 待审核
   */
  PENDING = 1,
  /**
   * 审核中
   */
  AUDITING = 2,
  /**
   * 审核通过
   */
  PASSED = 3,
  /**
   * 审核未通过
   */
  FAILED = 4,
}

/**
 * 评价红包状态
 */
export enum CommentRechargeStatus {
  /**
   * 初始化
   */
  INIT = 0,
  /**
   * 成功
   */
  SUCCESS = 1,
  /**
   * 失败
   */
  FAILED = 2,
}

/**
 * 用于iframe嵌套三方地址时使用当前域名打开 /misc/affiliate
 * 解决ios iframe 地址有重定向行为的三方地址不能正常展示
 */
export const YXH_OPEN_CUSTOM_DOMAIN = 'https://direct.vjia-tech.cn/';

// 宿主侧 iframe → 原生 代理白名单：与 open-sdk/yxh-1.1.2.js 的 actionList 对齐，
// 仅允许代理这些 action，防止三方 iframe 借助宿主任意调用原生能力。
// 同步点：public/open-sdk/yxh-1.1.2.js 中的 actionList（SDK 端 receive 校验）；本列表变化时需同步。
export const YXH_BRIDGE_PROXY_ACTIONS = ['getPhoneNumber', 'getAppInfo', 'closeCurrentWebView'];
// iframe postMessage 事件名
export const BRIDGE_INVOKE_EVENT = 'YXH_JS_BRIDGE_INVOKE';
export const BRIDGE_RECEIVE_EVENT = 'YXH_JS_BRIDGE_RECEIVE';

/**
 * 搭售产品交互模式
 */
export enum ProductInteractionMode {
  POPUP = 'productPopUp',
  CARD_POPUP = 'productCardAndPopUp',
}
